// https://github.com/naxeem/maldives-atoll-islands

// Define an interface for each island object
interface Island {
  atoll: string;
  type: string;
  name: string;
  name2?: string;
  value: string;
  value2?: string;
  alt_name: string | null;
  latitude: string;
  longitude: string;
  flags: string[];
}

// Define a type for the atoll keys

// Define the main interface for atollIslands
interface AtollIslands {
  [key: string]: Island[];
}

export function getAllIslands() {
  return Object.values(atollIslands).flatMap(islands => islands || []);
}

export function getInhabitedIslands() {
  return Object.values(atollIslands)
    .flatMap(islands => islands || [])
    .filter(i => i.flags?.includes("I"));
}

export function getIslandOptions(flag?: string) {
  return Object.values(atollIslands)
    .flat()
    .filter(i => !flag || i.flags?.includes(flag))
    .map(i => ({
      label: `${i.atoll} ${i.name}`,
      label2: `${i.name2} (${i.atoll})`,
      value: i.value,
      value2: i.value2,
      lat: i.latitude,
      lng: i.longitude,
    }));
}


export const atollIslands: AtollIslands = {
  HA: [
    {
      type: "Islands",
      name: "Alidhoo",
      atoll: "HA",
      value: "HA_Alidhoo",
      alt_name: null,
      latitude: "6.848611111",
      longitude: "73.15194444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Alidhuffarufinolhu",
      atoll: "HA",
      value: "HA_Alidhuffarufinolhu",
      alt_name: null,
      latitude: "6.860833333333333",
      longitude: "73.10444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Baarah",
      atoll: "HA",
      value: "HA_Baarah",
      alt_name: null,
      latitude: "6.810555556",
      longitude: "73.20861111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Beenaafushi",
      atoll: "HA",
      value: "HA_Beenaafushi",
      alt_name: "Bibeerah",
      latitude: "6.928333333",
      longitude: "73.13638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Berinmadhoo",
      atoll: "HA",
      value: "HA_Berinmadhoo",
      alt_name: null,
      latitude: "7.047222222",
      longitude: "72.97111111",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Dhapparuhuraa",
      atoll: "HA",
      value: "HA_Dhapparuhuraa",
      alt_name: null,
      latitude: "6.915277778",
      longitude: "73.21111111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhihdhoo",
      atoll: "HA",
      value: "HA_Dhihdhoo",
      alt_name: null,
      latitude: "6.886944444",
      longitude: "73.11333333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhonakulhi",
      atoll: "HA",
      value: "HA_Dhonakulhi",
      alt_name: null,
      latitude: "6.843055556",
      longitude: "73.05138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Filladhoo",
      atoll: "HA",
      value: "HA_Filladhoo",
      alt_name: null,
      latitude: "6.876666666666667",
      longitude: "73.22916666666667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gaamathikulhudhoo",
      atoll: "HA",
      value: "HA_Gaamathikulhudhoo",
      alt_name: null,
      latitude: "7.039166667",
      longitude: "72.98444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gallandhoo",
      atoll: "HA",
      value: "HA_Gallandhoo",
      alt_name: null,
      latitude: "6.946666667",
      longitude: "72.98305556",
      flags: ["P"],
    },
    {
      type: "Islands",
      name: "Govvaafushi",
      atoll: "HA",
      value: "HA_Govvaafushi",
      alt_name: null,
      latitude: "7.0125",
      longitude: "72.91916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hathifushi",
      atoll: "HA",
      value: "HA_Hathifushi",
      alt_name: null,
      latitude: "7.02",
      longitude: "72.83027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Huvahandhoo",
      atoll: "HA",
      value: "HA_Huvahandhoo",
      alt_name: null,
      latitude: "6.958888889",
      longitude: "72.905",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Huvarafushi",
      atoll: "HA",
      value: "HA_Huvarafushi",
      alt_name: null,
      latitude: "6.983055556",
      longitude: "72.89472222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ihavandhoo",
      atoll: "HA",
      value: "HA_Ihavandhoo",
      alt_name: null,
      latitude: "6.953055556",
      longitude: "72.92611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Innafinolhu",
      atoll: "HA",
      value: "HA_Innafinolhu",
      alt_name: null,
      latitude: "7.073611111",
      longitude: "72.81111111",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kan'daalifinolhu",
      atoll: "HA",
      value: "HA_Kan'daalifinolhu",
      alt_name: null,
      latitude: "6.926666666666667",
      longitude: "73.13055555555555",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kelaa",
      atoll: "HA",
      value: "HA_Kelaa",
      alt_name: null,
      latitude: "6.954444444",
      longitude: "73.21611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kudafinolhu",
      atoll: "HA",
      value: "HA_Kudafinolhu",
      alt_name: null,
      latitude: "6.989444444444445",
      longitude: "72.88333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maafahi",
      atoll: "HA",
      value: "HA_Maafahi",
      alt_name: null,
      latitude: "6.828333333",
      longitude: "73.15638889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Maafinolhu",
      atoll: "HA",
      value: "HA_Maafinolhu",
      alt_name: null,
      latitude: "7.002222222",
      longitude: "72.86222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maarandhoo",
      atoll: "HA",
      value: "HA_Maarandhoo",
      alt_name: null,
      latitude: "6.8525",
      longitude: "72.98388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maarandhoofarufinolhu",
      atoll: "HA",
      value: "HA_Maarandhoofarufinolhu",
      alt_name: null,
      latitude: "6.828888888888889",
      longitude: "72.97194444444445",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Madulu",
      atoll: "HA",
      value: "HA_Madulu",
      alt_name: null,
      latitude: "7.054722222",
      longitude: "72.95305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Manafaru",
      atoll: "HA",
      value: "HA_Manafaru",
      alt_name: null,
      latitude: "6.996944444",
      longitude: "72.93972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Matheerah",
      atoll: "HA",
      value: "HA_Matheerah",
      alt_name: null,
      latitude: "7.0275",
      longitude: "72.81888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhafushi",
      atoll: "HA",
      value: "HA_Medhafushi",
      alt_name: "Medhufinolhu",
      latitude: "7.010555556",
      longitude: "72.93388889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mulhadhoo",
      atoll: "HA",
      value: "HA_Mulhadhoo",
      alt_name: null,
      latitude: "7.011944444",
      longitude: "72.99805556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mulidhoo",
      atoll: "HA",
      value: "HA_Mulidhoo",
      alt_name: null,
      latitude: "6.836111111",
      longitude: "73.01111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Muraidhoo",
      atoll: "HA",
      value: "HA_Muraidhoo",
      alt_name: null,
      latitude: "6.837777778",
      longitude: "73.16694444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Naridhoo",
      atoll: "HA",
      value: "HA_Naridhoo",
      alt_name: null,
      latitude: "6.895",
      longitude: "73.12666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Thakandhoo",
      atoll: "HA",
      value: "HA_Thakandhoo",
      alt_name: null,
      latitude: "6.843888889",
      longitude: "72.99527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thuraakunu",
      atoll: "HA",
      value: "HA_Thuraakunu",
      alt_name: null,
      latitude: "7.103888889",
      longitude: "72.89916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Uligamu",
      atoll: "HA",
      value: "HA_Uligamu",
      alt_name: null,
      latitude: "7.081944444",
      longitude: "72.92722222",
      flags: ["I", "H"],
    },
    {
      type: "Islands",
      name: "Un'gulifinolhu",
      atoll: "HA",
      value: "HA_Un'gulifinolhu",
      alt_name: null,
      latitude: "6.971111111111111",
      longitude: "72.90138888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Utheemu",
      atoll: "HA",
      value: "HA_Utheemu",
      alt_name: null,
      latitude: "6.834722222",
      longitude: "73.1125",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Van'gaaru",
      atoll: "HA",
      value: "HA_Van'gaaru",
      alt_name: null,
      latitude: "7.093055556",
      longitude: "72.87805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vashafaru",
      atoll: "HA",
      value: "HA_Vashafaru",
      alt_name: null,
      latitude: "6.8975",
      longitude: "73.16083333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Velifinolhu",
      atoll: "HA",
      value: "HA_Velifinolhu",
      alt_name: null,
      latitude: "6.994166667",
      longitude: "72.87444444",
      flags: ["U"],
    },
    {
      type: "Knoll (Thila)",
      name: "Gaafushi",
      atoll: "HA",
      value: "HA_Gaafushi",
      alt_name: null,
      latitude: "6.851944444",
      longitude: "73.0575",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Dhigufaruhuraa",
      atoll: "HA",
      value: "HA_Dhigufaruhuraa",
      alt_name: null,
      latitude: "6.925277777777778",
      longitude: "72.96972222222223",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Umuraiyfinolhu",
      atoll: "HA",
      value: "HA_Umuraiyfinolhu",
      alt_name: null,
      latitude: "7.009444444",
      longitude: "72.85083333",
      flags: ["U"],
    },
  ],
  HDH: [
    {
      type: "Islands",
      name: "Dhipparufushi",
      atoll: "HDH",
      value: "HDH_Dhipparufushi",
      alt_name: null,
      latitude: "6.318888889",
      longitude: "72.64055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Faridhoo",
      atoll: "HDH",
      value: "HDH_Faridhoo",
      alt_name: null,
      latitude: "6.784722222",
      longitude: "73.05388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fenboahuraa",
      atoll: "HDH",
      value: "HDH_Fenboahuraa",
      alt_name: null,
      latitude: "6.396388889",
      longitude: "72.69444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Finey",
      atoll: "HDH",
      value: "HDH_Finey",
      alt_name: null,
      latitude: "6.745833333",
      longitude: "73.05305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hanimaadhoo",
      atoll: "HDH",
      value: "HDH_Hanimaadhoo",
      alt_name: null,
      latitude: "6.756111111",
      longitude: "73.17305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hirimaradhoo",
      atoll: "HDH",
      value: "HDH_Hirimaradhoo",
      alt_name: null,
      latitude: "6.724722222",
      longitude: "73.02388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hirinaidhoo",
      atoll: "HDH",
      value: "HDH_Hirinaidhoo",
      alt_name: null,
      latitude: "6.701666667",
      longitude: "72.94805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hon'daafushi",
      atoll: "HDH",
      value: "HDH_Hon'daafushi",
      alt_name: null,
      latitude: "6.778055556",
      longitude: "73.12138889",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Hon'daidhoo",
      atoll: "HDH",
      value: "HDH_Hon'daidhoo",
      alt_name: null,
      latitude: "6.769722222",
      longitude: "73.08722222",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Innafushi",
      atoll: "HDH",
      value: "HDH_Innafushi",
      alt_name: null,
      latitude: "6.408888889",
      longitude: "72.64527778",
      flags: ["P"],
    },
    {
      type: "Islands",
      name: "Kanamana",
      atoll: "HDH",
      value: "HDH_Kanamana",
      alt_name: null,
      latitude: "6.705",
      longitude: "72.89916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kattalafushi",
      atoll: "HDH",
      value: "HDH_Kattalafushi",
      alt_name: null,
      latitude: "6.566666666666666",
      longitude: "72.98305555555555",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Keylakunu",
      atoll: "HDH",
      value: "HDH_Keylakunu",
      alt_name: null,
      latitude: "6.6025",
      longitude: "73.00888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudafarufasgandu",
      atoll: "HDH",
      value: "HDH_Kudafarufasgandu",
      alt_name: null,
      latitude: "6.711944444444445",
      longitude: "72.92500000000001",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudamuraidhoo",
      atoll: "HDH",
      value: "HDH_Kudamuraidhoo",
      alt_name: null,
      latitude: "6.642777778",
      longitude: "72.92",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kulhudhuffushi",
      atoll: "HDH",
      value: "HDH_Kulhudhuffushi",
      alt_name: null,
      latitude: "6.623333333",
      longitude: "73.06972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kumundhoo",
      atoll: "HDH",
      value: "HDH_Kumundhoo",
      alt_name: null,
      latitude: "6.571944444",
      longitude: "73.05222222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kun'burudhoo",
      atoll: "HDH",
      value: "HDH_Kun'burudhoo",
      alt_name: null,
      latitude: "6.658055556",
      longitude: "73.02722222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kurin'bee",
      atoll: "HDH",
      value: "HDH_Kurin'bee",
      alt_name: null,
      latitude: "6.665277778",
      longitude: "72.99638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maavaidhoo",
      atoll: "HDH",
      value: "HDH_Maavaidhoo",
      alt_name: null,
      latitude: "6.515277778",
      longitude: "73.05361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Makunudhoo",
      atoll: "HDH",
      value: "HDH_Makunudhoo",
      alt_name: null,
      latitude: "6.409444444",
      longitude: "72.705",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Muiri",
      atoll: "HDH",
      value: "HDH_Muiri",
      alt_name: null,
      latitude: "6.658055556",
      longitude: "72.93638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Naagoashi",
      atoll: "HDH",
      value: "HDH_Naagoashi",
      alt_name: null,
      latitude: "6.669722222",
      longitude: "72.90222222",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Naivaadhoo",
      atoll: "HDH",
      value: "HDH_Naivaadhoo",
      alt_name: null,
      latitude: "6.746666667",
      longitude: "72.93472222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Nellaidhoo",
      atoll: "HDH",
      value: "HDH_Nellaidhoo",
      alt_name: null,
      latitude: "6.714722222",
      longitude: "72.94666667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Neykurendhoo",
      atoll: "HDH",
      value: "HDH_Neykurendhoo",
      alt_name: null,
      latitude: "6.542222222",
      longitude: "72.98027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Nolhivaramu",
      atoll: "HDH",
      value: "HDH_Nolhivaramu",
      alt_name: null,
      latitude: "6.662222222",
      longitude: "73.08194444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Nolhivaranfaru",
      atoll: "HDH",
      value: "HDH_Nolhivaranfaru",
      alt_name: null,
      latitude: "6.696944444",
      longitude: "73.12",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ruffushi",
      atoll: "HDH",
      value: "HDH_Ruffushi",
      alt_name: null,
      latitude: "6.758611111111111",
      longitude: "72.9388888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Theefaridhoo",
      atoll: "HDH",
      value: "HDH_Theefaridhoo",
      alt_name: null,
      latitude: "6.740277778",
      longitude: "73.03333333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Vaikaradhoo",
      atoll: "HDH",
      value: "HDH_Vaikaradhoo",
      alt_name: null,
      latitude: "6.549444444",
      longitude: "72.95305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vaikaramuraidhoo",
      atoll: "HDH",
      value: "HDH_Vaikaramuraidhoo",
      alt_name: null,
      latitude: "6.540555556",
      longitude: "72.89805556",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Veligan'du",
      atoll: "HDH",
      value: "HDH_Veligan'du",
      alt_name: "VeligauU",
      latitude: "6.754444444444444",
      longitude: "72.93833333333333",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kuredhigadu",
      atoll: "HDH",
      value: "HDH_Kuredhigadu",
      alt_name: "Huskuredhi",
      latitude: "6.678513888888889",
      longitude: "73.10510277777777",
      flags: [],
    },
  ],
  SH: [
    {
      type: "Islands",
      name: "Bileiyfahi",
      atoll: "SH",
      value: "SH_Bileiyfahi",
      alt_name: null,
      latitude: "6.338055556",
      longitude: "72.975",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Bis alhaahuraa",
      atoll: "SH",
      value: "SH_Bis alhaahuraa",
      alt_name: null,
      latitude: "6.155",
      longitude: "73.2925",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boduhuraa",
      atoll: "SH",
      value: "SH_Boduhuraa",
      alt_name: null,
      latitude: "6.071666667",
      longitude: "73.04388888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bolissafaru",
      atoll: "SH",
      value: "SH_Bolissafaru",
      alt_name: null,
      latitude: "5.980833333",
      longitude: "73.11083333",
      flags: ["P"],
    },
    {
      type: "Islands",
      name: "Dhigurah",
      atoll: "SH",
      value: "SH_Dhigurah",
      alt_name: null,
      latitude: "6.029444444444445",
      longitude: "73.06861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dholhiyadhoo",
      atoll: "SH",
      value: "SH_Dholhiyadhoo",
      alt_name: null,
      latitude: "5.9944444444444445",
      longitude: "73.21111111111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dholhiyadhookudarah",
      atoll: "SH",
      value: "SH_Dholhiyadhookudarah",
      alt_name: null,
      latitude: "5.99",
      longitude: "73.22416666666666",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhonvelihuraa",
      atoll: "SH",
      value: "SH_Dhonvelihuraa",
      alt_name: "Thahbeyhuraa",
      latitude: "6.184166667",
      longitude: "73.29861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ekasdhoo",
      atoll: "SH",
      value: "SH_Ekasdhoo",
      alt_name: null,
      latitude: "6.070833333",
      longitude: "73.28444444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Eriadhoo",
      atoll: "SH",
      value: "SH_Eriadhoo",
      alt_name: null,
      latitude: "6.103888889",
      longitude: "73.28694444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Farukolhu",
      atoll: "SH",
      value: "SH_Farukolhu",
      alt_name: null,
      latitude: "6.191666667",
      longitude: "73.2975",
      flags: ["PR", "ADF,H"],
    },
    {
      type: "Islands",
      name: "Feevah",
      atoll: "SH",
      value: "SH_Feevah",
      alt_name: null,
      latitude: "6.348888889",
      longitude: "73.20916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Feydhoo",
      atoll: "SH",
      value: "SH_Feydhoo",
      alt_name: null,
      latitude: "6.360555556",
      longitude: "73.04861111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Firubaidhoo",
      atoll: "SH",
      value: "SH_Firubaidhoo",
      alt_name: null,
      latitude: "6.114166667",
      longitude: "73.2275",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Foakaidhoo",
      atoll: "SH",
      value: "SH_Foakaidhoo",
      alt_name: null,
      latitude: "6.326388889",
      longitude: "73.14916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Funadhoo",
      atoll: "SH",
      value: "SH_Funadhoo",
      alt_name: null,
      latitude: "6.149166667",
      longitude: "73.29027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fushifaru",
      atoll: "SH",
      value: "SH_Fushifaru",
      alt_name: null,
      latitude: "6.395277778",
      longitude: "72.92583333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gaakoshibi",
      atoll: "SH",
      value: "SH_Gaakoshibi",
      alt_name: null,
      latitude: "6.286388889",
      longitude: "73.01194444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gallaidhoo",
      atoll: "SH",
      value: "SH_Gallaidhoo",
      alt_name: null,
      latitude: "5.968888889",
      longitude: "73.12444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Goidhoo",
      atoll: "SH",
      value: "SH_Goidhoo",
      alt_name: null,
      latitude: "6.43",
      longitude: "72.92972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gonaafarufinolhu",
      atoll: "SH",
      value: "SH_Gonaafarufinolhu",
      alt_name: null,
      latitude: "6.465555556",
      longitude: "72.89888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Horubadhoo",
      atoll: "SH",
      value: "SH_Horubadhoo",
      alt_name: "Hirubadhoo",
      latitude: "6.187777778",
      longitude: "73.24527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hurasfaru",
      atoll: "SH",
      value: "SH_Hurasfaru",
      alt_name: null,
      latitude: "6.139722222",
      longitude: "73.03722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kakaa eriyadhoo",
      atoll: "SH",
      value: "SH_Kakaa eriyadhoo",
      alt_name: null,
      latitude: "6.477777778",
      longitude: "72.90222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'baalifaru",
      atoll: "SH",
      value: "SH_Kan'baalifaru",
      alt_name: null,
      latitude: "6.123611111111111",
      longitude: "73.25555555555556",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Kan'ditheemu",
      atoll: "SH",
      value: "SH_Kan'ditheemu",
      alt_name: "",
      latitude: "6.440277778",
      longitude: "72.91638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Keekimini",
      atoll: "SH",
      value: "SH_Keekimini",
      alt_name: null,
      latitude: "6.007222222",
      longitude: "73.11166667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Komandoo",
      atoll: "SH",
      value: "SH_Komandoo",
      alt_name: null,
      latitude: "6.053888889",
      longitude: "73.05416667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kudadhoo",
      atoll: "SH",
      value: "SH_Kudadhoo",
      alt_name: null,
      latitude: "6.435833333",
      longitude: "72.90722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudafarufinolhu",
      atoll: "SH",
      value: "SH_Kudafarufinolhu",
      alt_name: null,
      latitude: "6.064444444444444",
      longitude: "73.04444444444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudalhaimendhoo",
      atoll: "SH",
      value: "SH_Kudalhaimendhoo",
      alt_name: null,
      latitude: "6.015",
      longitude: "73.29555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Lhaimagu",
      atoll: "SH",
      value: "SH_Lhaimagu",
      alt_name: null,
      latitude: "6.163888889",
      longitude: "73.25138889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maakan'doodhoo",
      atoll: "SH",
      value: "SH_Maakan'doodhoo",
      alt_name: null,
      latitude: "6.234722222",
      longitude: "73.26722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maaun'goodhoo",
      atoll: "SH",
      value: "SH_Maaun'goodhoo",
      alt_name: null,
      latitude: "6.036666667",
      longitude: "73.28361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Madidhoo",
      atoll: "SH",
      value: "SH_Madidhoo",
      alt_name: null,
      latitude: "6.3025",
      longitude: "73.10888889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Madikurehdhoo",
      atoll: "SH",
      value: "SH_Madikurehdhoo",
      alt_name: null,
      latitude: "6.284166667",
      longitude: "73.15083333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Mairah",
      atoll: "SH",
      value: "SH_Mairah",
      alt_name: "Dhiguvelidhoo",
      latitude: "6.019166667",
      longitude: "73.08777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maroshi",
      atoll: "SH",
      value: "SH_Maroshi",
      alt_name: null,
      latitude: "6.209444444",
      longitude: "73.06111111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mathikomandoo",
      atoll: "SH",
      value: "SH_Mathikomandoo",
      alt_name: null,
      latitude: "6.056944444",
      longitude: "73.04583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhukun'burudhoo",
      atoll: "SH",
      value: "SH_Medhukun'burudhoo",
      alt_name: null,
      latitude: "6.196944444",
      longitude: "73.03",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Medhurah",
      atoll: "SH",
      value: "SH_Medhurah",
      alt_name: null,
      latitude: "6.023055555555556",
      longitude: "73.07888888888888",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Migoodhoo",
      atoll: "SH",
      value: "SH_Migoodhoo",
      alt_name: null,
      latitude: "6.228611111",
      longitude: "73.24111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Milandhoo",
      atoll: "SH",
      value: "SH_Milandhoo",
      alt_name: null,
      latitude: "6.286111111",
      longitude: "73.24444444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Naainfarufinolhu",
      atoll: "SH",
      value: "SH_Naainfarufinolhu",
      alt_name: null,
      latitude: "6.203055555555555",
      longitude: "72.99861111111112",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Naalaahuraa",
      atoll: "SH",
      value: "SH_Naalaahuraa",
      alt_name: null,
      latitude: "6.127777777777777",
      longitude: "73.0363888888889",
      flags: ["P"],
    },
    {
      type: "Islands",
      name: "Nalandhoo",
      atoll: "SH",
      value: "SH_Nalandhoo",
      alt_name: null,
      latitude: "6.324444444",
      longitude: "73.22888889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Narudhoo",
      atoll: "SH",
      value: "SH_Narudhoo",
      alt_name: null,
      latitude: "6.264166667",
      longitude: "73.21777778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Narurin'budhoo",
      atoll: "SH",
      value: "SH_Narurin'budhoo",
      alt_name: null,
      latitude: "6.279166667",
      longitude: "73.19555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Neyo",
      atoll: "SH",
      value: "SH_Neyo",
      alt_name: null,
      latitude: "6.45",
      longitude: "73.05972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Noomaraa",
      atoll: "SH",
      value: "SH_Noomaraa",
      alt_name: null,
      latitude: "6.433888889",
      longitude: "73.06888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Raggan'duhuraa",
      atoll: "SH",
      value: "SH_Raggan'duhuraa",
      alt_name: null,
      latitude: "6.111944444444444",
      longitude: "73.03833333333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vagaru",
      atoll: "SH",
      value: "SH_Vagaru",
      alt_name: null,
      latitude: "6.089444444444444",
      longitude: "73.2038888888889",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Naainfaru",
      atoll: "SH",
      value: "SH_Naainfaru",
      alt_name: null,
      latitude: "6.203055555555555",
      longitude: "72.99861111111112",
      flags: ["U"],
    },
  ],
  N: [
    {
      type: "Islands",
      name: "Ban'daidhidhdhoo",
      atoll: "N",
      value: "N_Ban'daidhidhdhoo",
      alt_name: null,
      latitude: "5.685277778",
      longitude: "73.2575",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Bodufushi falhu)",
      atoll: "N",
      value: "N_Bodufushi falhu)",
      alt_name: "Ehdhupparu",
      latitude: "5.698611111",
      longitude: "73.41138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodulhaimendhoo",
      atoll: "N",
      value: "N_Bodulhaimendhoo",
      alt_name: null,
      latitude: "6",
      longitude: "73.30277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalaidhoo",
      atoll: "N",
      value: "N_Kalaidhoo",
      alt_name: null,
      latitude: "5.983333333",
      longitude: "73.32333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Burehifasdhoo",
      atoll: "N",
      value: "N_Burehifasdhoo",
      alt_name: null,
      latitude: "5.965277778",
      longitude: "73.36805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dheefuram",
      atoll: "N",
      value: "N_Dheefuram",
      alt_name: null,
      latitude: "5.8875",
      longitude: "73.31805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhekenanfaru",
      atoll: "N",
      value: "N_Dhekenanfaru",
      alt_name: null,
      latitude: "5.92",
      longitude: "73.15638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhelibe ruh elhihuraa",
      atoll: "N",
      value: "N_Dhelibe ruh elhihuraa",
      alt_name: null,
      latitude: "5.807222222222222",
      longitude: "73.45666666666666",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigurah",
      atoll: "N",
      value: "N_Dhigurah",
      alt_name: null,
      latitude: "5.732222222",
      longitude: "73.35916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhonaeri kan'doodhoo",
      atoll: "N",
      value: "N_Dhonaeri kan'doodhoo",
      alt_name: null,
      latitude: "5.646111111",
      longitude: "73.32916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ehdhuffaru mairah",
      atoll: "N",
      value: "N_Ehdhuffaru mairah",
      alt_name: null,
      latitude: "5.695277778",
      longitude: "73.40833333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Ekulhivaru",
      atoll: "N",
      value: "N_Ekulhivaru",
      alt_name: null,
      latitude: "5.949722222",
      longitude: "73.30694444",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Farumuli",
      atoll: "N",
      value: "N_Farumuli",
      alt_name: null,
      latitude: "5.864722222",
      longitude: "73.47527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Felivaru",
      atoll: "N",
      value: "N_Felivaru",
      alt_name: null,
      latitude: "5.835555556",
      longitude: "73.30611111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Fohdhipparu",
      atoll: "N",
      value: "N_Fohdhipparu",
      alt_name: null,
      latitude: "5.753611111111111",
      longitude: "73.20833333333334",
      flags: ["P"],
    },
    {
      type: "Islands",
      name: "Fohdhoo",
      atoll: "N",
      value: "N_Fohdhoo",
      alt_name: null,
      latitude: "5.743333333",
      longitude: "73.21583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Orimasvaru",
      atoll: "N",
      value: "N_Orimasvaru",
      alt_name: null,
      latitude: "5.8630555555555555",
      longitude: "73.20666666666666",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Goan'bilivaadhoo",
      atoll: "N",
      value: "N_Goan'bilivaadhoo",
      alt_name: null,
      latitude: "5.8225",
      longitude: "73.38722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hen'badhoo",
      atoll: "N",
      value: "N_Hen'badhoo",
      alt_name: null,
      latitude: "5.967222222",
      longitude: "73.39277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Holhudhoo",
      atoll: "N",
      value: "N_Holhudhoo",
      alt_name: null,
      latitude: "5.754722222",
      longitude: "73.26277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Holhumeedhoo",
      atoll: "N",
      value: "N_Holhumeedhoo",
      alt_name: null,
      latitude: "5.751111111",
      longitude: "73.24916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Huivani",
      atoll: "N",
      value: "N_Huivani",
      alt_name: null,
      latitude: "5.913333333",
      longitude: "73.31555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hulhuhdhoo",
      atoll: "N",
      value: "N_Hulhuhdhoo",
      alt_name: null,
      latitude: "5.815",
      longitude: "73.31861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Huvan'dhumaavattaru",
      atoll: "N",
      value: "N_Huvan'dhumaavattaru",
      alt_name: null,
      latitude: "5.845",
      longitude: "73.445",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "In'guraidhoo",
      atoll: "N",
      value: "N_In'guraidhoo",
      alt_name: null,
      latitude: "5.796944444",
      longitude: "73.34444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaalhugemendhoo",
      atoll: "N",
      value: "N_Kaalhugemendhoo",
      alt_name: "Gemendhoo",
      latitude: "5.787222222222222",
      longitude: "73.35388888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kafakomandoo",
      atoll: "N",
      value: "N_Kafakomandoo",
      alt_name: null,
      latitude: "5.961944444",
      longitude: "73.38611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bomasdhoo",
      atoll: "N",
      value: "N_Bomasdhoo",
      alt_name: null,
      latitude: "5.9725",
      longitude: "73.34555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'dinmaahuraa",
      atoll: "N",
      value: "N_Kan'dinmaahuraa",
      alt_name: null,
      latitude: "5.8575",
      longitude: "73.48027777777779",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Karinma",
      atoll: "N",
      value: "N_Karinma",
      alt_name: null,
      latitude: "5.658888888888889",
      longitude: "73.37222222222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Karinmavattaru",
      atoll: "N",
      value: "N_Karinmavattaru",
      alt_name: null,
      latitude: "5.67",
      longitude: "73.38694444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kedhivaru",
      atoll: "N",
      value: "N_Kedhivaru",
      alt_name: null,
      latitude: "5.851944444",
      longitude: "73.33611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ken'dhikulhudhoo",
      atoll: "N",
      value: "N_Ken'dhikulhudhoo",
      alt_name: null,
      latitude: "5.952222222",
      longitude: "73.41583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kudafari",
      atoll: "N",
      value: "N_Kudafari",
      alt_name: null,
      latitude: "5.8825",
      longitude: "73.4",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kudafunafaru",
      atoll: "N",
      value: "N_Kudafunafaru",
      alt_name: "Kudafarumaafaru",
      latitude: "5.885277778",
      longitude: "73.37777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudafushi",
      atoll: "N",
      value: "N_Kudafushi",
      alt_name: "Ehdhupparufalhu",
      latitude: "5.703055555555555",
      longitude: "73.41277777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kunnumala",
      atoll: "N",
      value: "N_Kunnumala",
      alt_name: null,
      latitude: "5.952777778",
      longitude: "73.13305556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kuramaadhoo",
      atoll: "N",
      value: "N_Kuramaadhoo",
      alt_name: null,
      latitude: "5.873055556",
      longitude: "73.14361111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kuredhivaru",
      atoll: "N",
      value: "N_Kuredhivaru",
      alt_name: null,
      latitude: "5.875",
      longitude: "73.34305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Landhoo",
      atoll: "N",
      value: "N_Landhoo",
      alt_name: null,
      latitude: "5.881388889",
      longitude: "73.46611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Lhohi",
      atoll: "N",
      value: "N_Lhohi",
      alt_name: null,
      latitude: "5.816111111",
      longitude: "73.3775",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Loafaru",
      atoll: "N",
      value: "N_Loafaru",
      alt_name: null,
      latitude: "5.785555556",
      longitude: "73.27583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maafaru H)",
      atoll: "N",
      value: "N_Maafaru H)",
      alt_name: "ADF,",
      latitude: "5.833611111111111",
      longitude: "73.48111111111112",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maafunafaru",
      atoll: "N",
      value: "N_Maafunafaru",
      alt_name: null,
      latitude: "5.860833333",
      longitude: "73.36611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maakanaafushi",
      atoll: "N",
      value: "N_Maakanaafushi",
      alt_name: "Ehdhupparufalhu",
      latitude: "5.727777777777778",
      longitude: "73.41611111111112",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maakurehdhoo",
      atoll: "N",
      value: "N_Maakurehdhoo",
      alt_name: null,
      latitude: "5.696388889",
      longitude: "73.31166667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Maalhendhoo",
      atoll: "N",
      value: "N_Maalhendhoo",
      alt_name: null,
      latitude: "5.901944444",
      longitude: "73.45611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maavahdhoo",
      atoll: "N",
      value: "N_Maavahdhoo",
      alt_name: null,
      latitude: "5.814722222",
      longitude: "73.32611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maavelavaru",
      atoll: "N",
      value: "N_Maavelavaru",
      alt_name: null,
      latitude: "5.805277778",
      longitude: "73.17138889",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Magoodhoo",
      atoll: "N",
      value: "N_Magoodhoo",
      alt_name: null,
      latitude: "5.776388889",
      longitude: "73.36222222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Manadhoo",
      atoll: "N",
      value: "N_Manadhoo",
      alt_name: null,
      latitude: "5.765555556",
      longitude: "73.41055556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Medhafushi",
      atoll: "N",
      value: "N_Medhafushi",
      alt_name: null,
      latitude: "5.744166667",
      longitude: "73.32388889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Medhufaru",
      atoll: "N",
      value: "N_Medhufaru",
      alt_name: null,
      latitude: "5.713333333",
      longitude: "73.41472222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Miladhoo",
      atoll: "N",
      value: "N_Miladhoo",
      alt_name: null,
      latitude: "5.790555555555556",
      longitude: "73.3625",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Minaavaru",
      atoll: "N",
      value: "N_Minaavaru",
      alt_name: null,
      latitude: "5.768333333",
      longitude: "73.34333333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Fushivelavaru",
      atoll: "N",
      value: "N_Fushivelavaru",
      alt_name: null,
      latitude: "5.8308333333333335",
      longitude: "73.20916666666668",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Orivaru",
      atoll: "N",
      value: "N_Orivaru",
      alt_name: null,
      latitude: "5.801944444",
      longitude: "73.2975",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Orivarukudarah",
      atoll: "N",
      value: "N_Orivarukudarah",
      alt_name: "Rasgefushi",
      latitude: "5.800833333333333",
      longitude: "73.2936111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Raafushi",
      atoll: "N",
      value: "N_Raafushi",
      alt_name: null,
      latitude: "5.647777778",
      longitude: "73.29861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Raalhulaakolhu",
      atoll: "N",
      value: "N_Raalhulaakolhu",
      alt_name: "Raalhugandu",
      latitude: "5.686666667",
      longitude: "73.40444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Randheli",
      atoll: "N",
      value: "N_Randheli",
      alt_name: null,
      latitude: "5.691666667",
      longitude: "73.34055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Than'burudhoo",
      atoll: "N",
      value: "N_Than'burudhoo",
      alt_name: null,
      latitude: "5.716388889",
      longitude: "73.23444444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Than'burudhuffushi",
      atoll: "N",
      value: "N_Than'burudhuffushi",
      alt_name: "Thanburudhu'faru",
      latitude: "5.708888889",
      longitude: "73.24138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Tholhendhoo",
      atoll: "N",
      value: "N_Tholhendhoo",
      alt_name: null,
      latitude: "5.920555556",
      longitude: "73.43638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thoshigan'dukolhu",
      atoll: "N",
      value: "N_Thoshigan'dukolhu",
      alt_name: "Eh'dhupparufalhu",
      latitude: "5.732777778",
      longitude: "73.41333333333334",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vavathi",
      atoll: "N",
      value: "N_Vavathi",
      alt_name: null,
      latitude: "5.796111111",
      longitude: "73.22722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Velidhoo",
      atoll: "N",
      value: "N_Velidhoo",
      alt_name: null,
      latitude: "5.663888889",
      longitude: "73.27416667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vihafarufinolhu",
      atoll: "N",
      value: "N_Vihafarufinolhu",
      alt_name: null,
      latitude: "5.681388888888889",
      longitude: "73.27972222222222",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Kudarah kudarah)",
      atoll: "N",
      value: "N_Kudarah kudarah)",
      alt_name: "Felivaru",
      latitude: "5.832777778",
      longitude: "73.31388889",
      flags: ["U"],
    },
  ],
  R: [
    {
      type: "Islands",
      name: "Aarah",
      atoll: "R",
      value: "R_Aarah",
      alt_name: null,
      latitude: "5.446944444",
      longitude: "72.94111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Alifushi",
      atoll: "R",
      value: "R_Alifushi",
      alt_name: null,
      latitude: "5.967222222",
      longitude: "72.95333333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Angaagiri",
      atoll: "R",
      value: "R_Angaagiri",
      alt_name: null,
      latitude: "5.556388888888889",
      longitude: "72.94583333333334",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "An'golhitheemu",
      atoll: "R",
      value: "R_An'golhitheemu",
      alt_name: null,
      latitude: "5.7925",
      longitude: "73.00638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Arilundhoo",
      atoll: "R",
      value: "R_Arilundhoo",
      alt_name: null,
      latitude: "5.66",
      longitude: "72.9575",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ban'daveri",
      atoll: "R",
      value: "R_Ban'daveri",
      alt_name: null,
      latitude: "5.6225",
      longitude: "72.85222222222221",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufarufinolhu",
      atoll: "R",
      value: "R_Bodufarufinolhu",
      alt_name: null,
      latitude: "5.529722222",
      longitude: "72.80472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufen maaen'budhoo",
      atoll: "R",
      value: "R_Bodufen maaen'budhoo",
      alt_name: null,
      latitude: "5.629166667",
      longitude: "72.92388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufushi",
      atoll: "R",
      value: "R_Bodufushi",
      alt_name: null,
      latitude: "5.5075",
      longitude: "72.96861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boduhaiykodi",
      atoll: "R",
      value: "R_Boduhaiykodi",
      alt_name: null,
      latitude: "5.609722222",
      longitude: "72.96944444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Boduhuraa",
      atoll: "R",
      value: "R_Boduhuraa",
      alt_name: null,
      latitude: "5.417222222222223",
      longitude: "73.0225",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dheburidheythereyvaadhoo",
      atoll: "R",
      value: "R_Dheburidheythereyvaadhoo",
      alt_name: null,
      latitude: "5.400555556",
      longitude: "72.99083333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Dhekunumaafaru",
      atoll: "R",
      value: "R_Dhekunumaafaru",
      alt_name: null,
      latitude: "5.433611111",
      longitude: "72.895",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigali",
      atoll: "R",
      value: "R_Dhigali",
      alt_name: null,
      latitude: "5.475",
      longitude: "72.95333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhikkurehdhoo",
      atoll: "R",
      value: "R_Dhikkurehdhoo",
      alt_name: null,
      latitude: "5.576666667",
      longitude: "72.95694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhinnaafushi",
      atoll: "R",
      value: "R_Dhinnaafushi",
      alt_name: null,
      latitude: "5.589166667",
      longitude: "72.83333055555555",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhoragali",
      atoll: "R",
      value: "R_Dhoragali",
      alt_name: null,
      latitude: "5.494722222",
      longitude: "72.99777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhuvaafaru",
      atoll: "R",
      value: "R_Dhuvaafaru",
      alt_name: null,
      latitude: "5.628611111",
      longitude: "73.04166667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhuvaafaruhuraa",
      atoll: "R",
      value: "R_Dhuvaafaruhuraa",
      alt_name: null,
      latitude: "5.639722222",
      longitude: "73.04166666666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ethigan'du jehihuraa",
      atoll: "R",
      value: "R_Ethigan'du jehihuraa",
      alt_name: null,
      latitude: "5.424722222222223",
      longitude: "73.03027777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ehthigili",
      atoll: "R",
      value: "R_Ehthigili",
      alt_name: null,
      latitude: "5.978611111",
      longitude: "72.93805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Faarufushi",
      atoll: "R",
      value: "R_Faarufushi",
      alt_name: "Fararafushi",
      latitude: "5.767777778",
      longitude: "72.965",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fainu",
      atoll: "R",
      value: "R_Fainu",
      alt_name: null,
      latitude: "5.463333333",
      longitude: "73.03444444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fasgan'dufaru",
      atoll: "R",
      value: "R_Fasgan'dufaru",
      alt_name: "Husveli",
      latitude: "5.758055556",
      longitude: "72.93861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fasmendhoo",
      atoll: "R",
      value: "R_Fasmendhoo",
      alt_name: null,
      latitude: "5.494166667",
      longitude: "72.88138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenfushi",
      atoll: "R",
      value: "R_Fenfushi",
      alt_name: null,
      latitude: "5.381944444",
      longitude: "72.90194444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Filaidhoo",
      atoll: "R",
      value: "R_Filaidhoo",
      alt_name: null,
      latitude: "5.491666667",
      longitude: "72.93805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fuggiri",
      atoll: "R",
      value: "R_Fuggiri",
      alt_name: null,
      latitude: "5.724166667",
      longitude: "72.85444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Furaveri",
      atoll: "R",
      value: "R_Furaveri",
      alt_name: "Faruveri",
      latitude: "5.440277778",
      longitude: "72.90805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gaaun'doodhoo",
      atoll: "R",
      value: "R_Gaaun'doodhoo",
      alt_name: null,
      latitude: "5.749166667",
      longitude: "73.01555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Giraavaru",
      atoll: "R",
      value: "R_Giraavaru",
      alt_name: "",
      latitude: "5.588333333",
      longitude: "72.86111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Goboshi",
      atoll: "R",
      value: "R_Goboshi",
      alt_name: null,
      latitude: "5.551666666666667",
      longitude: "72.88416666666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Goiymaru",
      atoll: "R",
      value: "R_Goiymaru",
      alt_name: null,
      latitude: "5.63",
      longitude: "72.88777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Goyyafaru",
      atoll: "R",
      value: "R_Goyyafaru",
      alt_name: null,
      latitude: "5.564722222",
      longitude: "72.92722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hiboodhoo",
      atoll: "R",
      value: "R_Hiboodhoo",
      alt_name: null,
      latitude: "5.6125",
      longitude: "72.91888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hiraveri",
      atoll: "R",
      value: "R_Hiraveri",
      alt_name: "Husveli",
      latitude: "5.571666667",
      longitude: "72.86916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhudhoo",
      atoll: "R",
      value: "R_Hulhudhoo",
      alt_name: null,
      latitude: "5.738611111111111",
      longitude: "73.01888888888888",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhudhuffaaru",
      atoll: "R",
      value: "R_Hulhudhuffaaru",
      alt_name: null,
      latitude: "5.761944444",
      longitude: "73.01222222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Huruvalhi",
      atoll: "R",
      value: "R_Huruvalhi",
      alt_name: null,
      latitude: "5.391944444",
      longitude: "72.97888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ifuru",
      atoll: "R",
      value: "R_Ifuru",
      alt_name: null,
      latitude: "5.707222222",
      longitude: "73.02416667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "In'guraidhoo",
      atoll: "R",
      value: "R_In'guraidhoo",
      alt_name: null,
      latitude: "5.476944444",
      longitude: "73.03638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Innamaadhoo",
      atoll: "R",
      value: "R_Innamaadhoo",
      alt_name: null,
      latitude: "5.549444444",
      longitude: "73.04416667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kan'dholhudoo",
      atoll: "R",
      value: "R_Kan'dholhudoo",
      alt_name: null,
      latitude: "5.618611111",
      longitude: "72.855",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kandhoomeehunge lhaan'bugali",
      atoll: "R",
      value: "R_Kandhoomeehunge lhaan'bugali",
      alt_name: null,
      latitude: "5.730555556",
      longitude: "72.91888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'doogan'du",
      atoll: "R",
      value: "R_Kan'doogan'du",
      alt_name: null,
      latitude: "5.780833333",
      longitude: "72.87611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kinolhas",
      atoll: "R",
      value: "R_Kinolhas",
      alt_name: null,
      latitude: "5.448333333",
      longitude: "73.02888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kothaifaru",
      atoll: "R",
      value: "R_Kothaifaru",
      alt_name: null,
      latitude: "5.525277778",
      longitude: "72.84277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kottefaru",
      atoll: "R",
      value: "R_Kottefaru",
      alt_name: null,
      latitude: "5.509444444",
      longitude: "73.04194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudafen maaen'boodhoo",
      atoll: "R",
      value: "R_Kudafen maaen'boodhoo",
      alt_name: null,
      latitude: "5.625",
      longitude: "72.93527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudafushi",
      atoll: "R",
      value: "R_Kudafushi",
      alt_name: null,
      latitude: "5.510555556",
      longitude: "72.98027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudakurathu",
      atoll: "R",
      value: "R_Kudakurathu",
      alt_name: null,
      latitude: "5.583611111",
      longitude: "73.04444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudalhosgiri",
      atoll: "R",
      value: "R_Kudalhosgiri",
      alt_name: null,
      latitude: "5.601666667",
      longitude: "72.91416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudathulhaadhoo",
      atoll: "R",
      value: "R_Kudathulhaadhoo",
      alt_name: null,
      latitude: "5.407222222",
      longitude: "72.89861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kukulhudhoo",
      atoll: "R",
      value: "R_Kukulhudhoo",
      alt_name: null,
      latitude: "5.458888889",
      longitude: "72.87083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kurehdhoo",
      atoll: "R",
      value: "R_Kurehdhoo",
      alt_name: "kolhikurehdhoo",
      latitude: "5.640555556",
      longitude: "72.89416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kuroshigiri",
      atoll: "R",
      value: "R_Kuroshigiri",
      alt_name: null,
      latitude: "5.513611111",
      longitude: "72.85",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lhaan'bugali",
      atoll: "R",
      value: "R_Lhaan'bugali",
      alt_name: null,
      latitude: "5.551944444",
      longitude: "72.87694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lhohi",
      atoll: "R",
      value: "R_Lhohi",
      alt_name: null,
      latitude: "5.461388889",
      longitude: "72.885",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Lin'boakandhoo",
      atoll: "R",
      value: "R_Lin'boakandhoo",
      alt_name: null,
      latitude: "5.730555556",
      longitude: "72.93416667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Lun'dhufushi",
      atoll: "R",
      value: "R_Lun'dhufushi",
      alt_name: null,
      latitude: "5.643888889",
      longitude: "72.98666667",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Maakurathu",
      atoll: "R",
      value: "R_Maakurathu",
      alt_name: null,
      latitude: "5.605833333",
      longitude: "73.04388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maamin'gili",
      atoll: "R",
      value: "R_Maamin'gili",
      alt_name: null,
      latitude: "5.650833333",
      longitude: "72.88472222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maamunagau",
      atoll: "R",
      value: "R_Maamunagau",
      alt_name: null,
      latitude: "5.360277778",
      longitude: "72.91888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maamunagaufinolhu",
      atoll: "R",
      value: "R_Maamunagaufinolhu",
      alt_name: "Husveli",
      latitude: "5.369444444",
      longitude: "72.87583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maanenfushi",
      atoll: "R",
      value: "R_Maanenfushi",
      alt_name: null,
      latitude: "5.7525",
      longitude: "72.96111111",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Maashigiri",
      atoll: "R",
      value: "R_Maashigiri",
      alt_name: null,
      latitude: "5.513888889",
      longitude: "72.82666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Madivaafaru",
      atoll: "R",
      value: "R_Madivaafaru",
      alt_name: null,
      latitude: "5.608055556",
      longitude: "72.98944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maduvvari",
      atoll: "R",
      value: "R_Maduvvari",
      alt_name: null,
      latitude: "5.486111111",
      longitude: "72.89583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mahidhoo",
      atoll: "R",
      value: "R_Mahidhoo",
      alt_name: null,
      latitude: "5.5375",
      longitude: "72.94388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meedhoo",
      atoll: "R",
      value: "R_Meedhoo",
      alt_name: null,
      latitude: "5.458055556",
      longitude: "72.95472222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Meedhupparu",
      atoll: "R",
      value: "R_Meedhupparu",
      alt_name: "",
      latitude: "5.455833333",
      longitude: "72.97972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mullaafushi",
      atoll: "R",
      value: "R_Mullaafushi",
      alt_name: "Husveli",
      latitude: "5.52",
      longitude: "72.90722222222223",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Muravandhoo",
      atoll: "R",
      value: "R_Muravandhoo",
      alt_name: null,
      latitude: "5.6075",
      longitude: "72.95222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Neyo",
      atoll: "R",
      value: "R_Neyo",
      alt_name: null,
      latitude: "5.4925",
      longitude: "73.03861111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Rasgetheemu",
      atoll: "R",
      value: "R_Rasgetheemu",
      alt_name: null,
      latitude: "5.8075",
      longitude: "73.00305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Rasmaadhoo",
      atoll: "R",
      value: "R_Rasmaadhoo",
      alt_name: null,
      latitude: "5.562777778",
      longitude: "73.04361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thaavathaa",
      atoll: "R",
      value: "R_Thaavathaa",
      alt_name: null,
      latitude: "5.484444444",
      longitude: "72.97555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ufulandhoo",
      atoll: "R",
      value: "R_Ufulandhoo",
      alt_name: null,
      latitude: "5.464166667",
      longitude: "72.91333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Un'goofaaru",
      atoll: "R",
      value: "R_Un'goofaaru",
      alt_name: null,
      latitude: "5.668055556",
      longitude: "73.03",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Un'gulu",
      atoll: "R",
      value: "R_Un'gulu",
      alt_name: null,
      latitude: "5.690555556",
      longitude: "73.02611111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Uthurumaafaru",
      atoll: "R",
      value: "R_Uthurumaafaru",
      alt_name: null,
      latitude: "5.669722222",
      longitude: "72.84555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vaadhoo",
      atoll: "R",
      value: "R_Vaadhoo",
      alt_name: null,
      latitude: "5.856388889",
      longitude: "72.99138889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vaffushi",
      atoll: "R",
      value: "R_Vaffushi",
      alt_name: null,
      latitude: "5.629166667",
      longitude: "72.86222222222221",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vaffushihuraa",
      atoll: "R",
      value: "R_Vaffushihuraa",
      alt_name: null,
      latitude: "5.6425",
      longitude: "72.83972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vandhoo",
      atoll: "R",
      value: "R_Vandhoo",
      alt_name: null,
      latitude: "5.531666667",
      longitude: "73.04166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Veyvah",
      atoll: "R",
      value: "R_Veyvah",
      alt_name: null,
      latitude: "5.766666667",
      longitude: "72.89305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vilin'gili",
      atoll: "R",
      value: "R_Vilin'gili",
      alt_name: null,
      latitude: "5.376388889",
      longitude: "72.95388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gemana",
      atoll: "R",
      value: "R_Gemana",
      alt_name: null,
      latitude: "5.537222222222222",
      longitude: "72.98472222222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Orimasfushi",
      atoll: "R",
      value: "R_Orimasfushi",
      alt_name: null,
      latitude: "5.5811111111111105",
      longitude: "72.90694444444445",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Minaadhoo",
      atoll: "R",
      value: "R_Minaadhoo",
      alt_name: null,
      latitude: "5.588055555555555",
      longitude: "72.92694444444444",
      flags: ["U"],
    },
  ],
  B: [
    {
      type: "Islands",
      name: "Ahivaffushi",
      atoll: "B",
      value: "B_Ahivaffushi",
      alt_name: null,
      latitude: "5.228333333",
      longitude: "72.85694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Aidhoo",
      atoll: "B",
      value: "B_Aidhoo",
      alt_name: null,
      latitude: "5.186944444",
      longitude: "73.16333333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Anhenunfushi",
      atoll: "B",
      value: "B_Anhenunfushi",
      alt_name: null,
      latitude: "5.341944444",
      longitude: "72.96861111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Bathalaa",
      atoll: "B",
      value: "B_Bathalaa",
      alt_name: null,
      latitude: "5.353333333333333",
      longitude: "73.06861111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boadhaafushifinolhu",
      atoll: "B",
      value: "B_Boadhaafushifinolhu",
      alt_name: null,
      latitude: "4.881666666666667",
      longitude: "72.89416666666668",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "B",
      value: "B_Bodufinolhu",
      alt_name: null,
      latitude: "5.007777778",
      longitude: "72.85722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boifushi",
      atoll: "B",
      value: "B_Boifushi",
      alt_name: null,
      latitude: "5.2975",
      longitude: "72.99361111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhakandhoo",
      atoll: "B",
      value: "B_Dhakandhoo",
      alt_name: null,
      latitude: "5.248333333",
      longitude: "72.89333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhandhoo",
      atoll: "B",
      value: "B_Dhandhoo",
      alt_name: null,
      latitude: "5.235555556",
      longitude: "73.16833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dharavandhoo",
      atoll: "B",
      value: "B_Dharavandhoo",
      alt_name: null,
      latitude: "5.157777778",
      longitude: "73.13027778",
      flags: ["I", "ADF,H"],
    },
    {
      type: "Islands",
      name: "Dhashufaruhuraa",
      atoll: "B",
      value: "B_Dhashufaruhuraa",
      alt_name: null,
      latitude: "4.8175",
      longitude: "72.91000000000001",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigudhefaru",
      atoll: "B",
      value: "B_Dhigudhefaru",
      alt_name: null,
      latitude: "5.235277778",
      longitude: "73.13833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigufaruvinagan'du",
      atoll: "B",
      value: "B_Dhigufaruvinagan'du",
      alt_name: null,
      latitude: "5.352222222",
      longitude: "72.99027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhonfanu",
      atoll: "B",
      value: "B_Dhonfanu",
      alt_name: null,
      latitude: "5.1875",
      longitude: "73.12277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhoogan'dufinolhu",
      atoll: "B",
      value: "B_Dhoogan'dufinolhu",
      alt_name: "u",
      latitude: "5.246944444",
      longitude: "73.15138888888889",
      flags: [],
    },
    {
      type: "Islands",
      name: "Dhunikolhu",
      atoll: "B",
      value: "B_Dhunikolhu",
      alt_name: null,
      latitude: "5.039722222",
      longitude: "72.88138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "En'boodhoo",
      atoll: "B",
      value: "B_En'boodhoo",
      alt_name: null,
      latitude: "5.063888889",
      longitude: "72.85583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Eydhafushi",
      atoll: "B",
      value: "B_Eydhafushi",
      alt_name: null,
      latitude: "5.103333333",
      longitude: "73.07",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fares",
      atoll: "B",
      value: "B_Fares",
      alt_name: null,
      latitude: "5.232222222",
      longitude: "72.87722222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fehendhoo",
      atoll: "B",
      value: "B_Fehendhoo",
      alt_name: null,
      latitude: "4.881388889",
      longitude: "72.96972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Finolhas",
      atoll: "B",
      value: "B_Finolhas",
      alt_name: null,
      latitude: "5.233611111",
      longitude: "73.11361111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fonimagoodhoo",
      atoll: "B",
      value: "B_Fonimagoodhoo",
      alt_name: null,
      latitude: "5.254722222",
      longitude: "73.16333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fulhadhoo",
      atoll: "B",
      value: "B_Fulhadhoo",
      alt_name: null,
      latitude: "4.884722222",
      longitude: "72.93277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Funadhoo",
      atoll: "B",
      value: "B_Funadhoo",
      alt_name: null,
      latitude: "5.274444444",
      longitude: "73.03305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaagan'dufaruhuraa",
      atoll: "B",
      value: "B_Gaagan'dufaruhuraa",
      alt_name: null,
      latitude: "5.369166666666667",
      longitude: "73.06083333333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaavilin'gili",
      atoll: "B",
      value: "B_Gaavilin'gili",
      alt_name: null,
      latitude: "5.061944444",
      longitude: "72.83722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gemendhoo",
      atoll: "B",
      value: "B_Gemendhoo",
      alt_name: null,
      latitude: "5.275277777777777",
      longitude: "73.01972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Goidhoo",
      atoll: "B",
      value: "B_Goidhoo",
      alt_name: null,
      latitude: "4.872777778",
      longitude: "72.99888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hanifaru",
      atoll: "B",
      value: "B_Hanifaru",
      alt_name: null,
      latitude: "5.1825",
      longitude: "73.13277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hanifaruhuraa",
      atoll: "B",
      value: "B_Hanifaruhuraa",
      alt_name: null,
      latitude: "5.1725",
      longitude: "73.15138888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hibalhidhoo",
      atoll: "B",
      value: "B_Hibalhidhoo",
      alt_name: null,
      latitude: "5.141111111",
      longitude: "73.11472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hirundhoo",
      atoll: "B",
      value: "B_Hirundhoo",
      alt_name: null,
      latitude: "5.216944444",
      longitude: "73.15333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hithaadhoo",
      atoll: "B",
      value: "B_Hithaadhoo",
      alt_name: null,
      latitude: "5.006944444",
      longitude: "72.92277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Horubadhoo",
      atoll: "B",
      value: "B_Horubadhoo",
      alt_name: null,
      latitude: "5.163055556",
      longitude: "73.05333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hulhudhoo",
      atoll: "B",
      value: "B_Hulhudhoo",
      alt_name: null,
      latitude: "5.274722222",
      longitude: "73.025",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maaddoo Hulhudhoo",
      atoll: "B",
      value: "B_Maaddoo Hulhudhoo",
      alt_name: null,
      latitude: "5.071111111111111",
      longitude: "73.03194444444445",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Innafushi",
      atoll: "B",
      value: "B_Innafushi",
      alt_name: null,
      latitude: "4.8775",
      longitude: "72.87861111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kamadhoo",
      atoll: "B",
      value: "B_Kamadhoo",
      alt_name: null,
      latitude: "5.281666667",
      longitude: "73.13666667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kanufusheegaathufinolhu",
      atoll: "B",
      value: "B_Kanufusheegaathufinolhu",
      alt_name: null,
      latitude: "5.013888889",
      longitude: "72.96277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kanufushi",
      atoll: "B",
      value: "B_Kanufushi",
      alt_name: null,
      latitude: "5.011388888888889",
      longitude: "72.95138888888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kashidhoo",
      atoll: "B",
      value: "B_Kashidhoo",
      alt_name: null,
      latitude: "5.296944444",
      longitude: "72.96861111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kashidhuffarufinolhu",
      atoll: "B",
      value: "B_Kashidhuffarufinolhu",
      alt_name: null,
      latitude: "5.295833333333333",
      longitude: "72.93333055555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kendhoo",
      atoll: "B",
      value: "B_Kendhoo",
      alt_name: null,
      latitude: "5.275277778",
      longitude: "73.01027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Keyodhoo",
      atoll: "B",
      value: "B_Keyodhoo",
      alt_name: null,
      latitude: "5.276666666666666",
      longitude: "72.99583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kihaadhoo",
      atoll: "B",
      value: "B_Kihaadhoo",
      alt_name: null,
      latitude: "5.215",
      longitude: "73.125",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kihaadhuffaru",
      atoll: "B",
      value: "B_Kihaadhuffaru",
      alt_name: null,
      latitude: "5.190833333",
      longitude: "73.13222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kihavah huravalhi",
      atoll: "B",
      value: "B_Kihavah huravalhi",
      alt_name: null,
      latitude: "5.295833333",
      longitude: "73.05666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudadhoo",
      atoll: "B",
      value: "B_Kudadhoo",
      alt_name: null,
      latitude: "5.028611111",
      longitude: "72.99138889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kudarikilu",
      atoll: "B",
      value: "B_Kudarikilu",
      alt_name: null,
      latitude: "5.300277778",
      longitude: "73.07083333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kunfunadhoo",
      atoll: "B",
      value: "B_Kunfunadhoo",
      alt_name: null,
      latitude: "5.112222222",
      longitude: "73.07722222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Lan'daagiraavaru",
      atoll: "B",
      value: "B_Lan'daagiraavaru",
      alt_name: null,
      latitude: "5.286111111",
      longitude: "73.11194444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maaddoo",
      atoll: "B",
      value: "B_Maaddoo",
      alt_name: null,
      latitude: "5.092777778",
      longitude: "73.0625",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maalhos",
      atoll: "B",
      value: "B_Maalhos",
      alt_name: null,
      latitude: "5.134444444",
      longitude: "73.10777778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maamaduvvari",
      atoll: "B",
      value: "B_Maamaduvvari",
      alt_name: null,
      latitude: "5.008888889",
      longitude: "72.94166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maarikilu",
      atoll: "B",
      value: "B_Maarikilu",
      alt_name: null,
      latitude: "5.334722222",
      longitude: "72.9525",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Madhirivaadhoo",
      atoll: "B",
      value: "B_Madhirivaadhoo",
      alt_name: null,
      latitude: "5.268611111",
      longitude: "73.16083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mathifaru",
      atoll: "B",
      value: "B_Mathifaru",
      alt_name: null,
      latitude: "4.815555556",
      longitude: "72.89027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhufinolhu gaathufinolhu",
      atoll: "B",
      value: "B_Medhufinolhu gaathufinolhu",
      alt_name: null,
      latitude: "5.015833333333333",
      longitude: "72.96638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mendhoo",
      atoll: "B",
      value: "B_Mendhoo",
      alt_name: null,
      latitude: "5.175",
      longitude: "72.99527778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Milaidhoo",
      atoll: "B",
      value: "B_Milaidhoo",
      alt_name: null,
      latitude: "5.266944444",
      longitude: "73.12805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Miriandhoo",
      atoll: "B",
      value: "B_Miriandhoo",
      alt_name: null,
      latitude: "5.063055556",
      longitude: "73.03083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Muhdhoo",
      atoll: "B",
      value: "B_Muhdhoo",
      alt_name: null,
      latitude: "5.206666667",
      longitude: "73.08444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Muthaafushi",
      atoll: "B",
      value: "B_Muthaafushi",
      alt_name: null,
      latitude: "5.078055556",
      longitude: "72.87722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Nelivarufinolhu",
      atoll: "B",
      value: "B_Nelivarufinolhu",
      alt_name: "",
      latitude: "5.125555556",
      longitude: "73.08527777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Nibiligaa",
      atoll: "B",
      value: "B_Nibiligaa",
      alt_name: null,
      latitude: "5.1725",
      longitude: "72.94416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhugiri",
      atoll: "B",
      value: "B_Olhugiri",
      alt_name: null,
      latitude: "5.001111111",
      longitude: "72.90583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thiladhoo",
      atoll: "B",
      value: "B_Thiladhoo",
      alt_name: null,
      latitude: "5.262222222",
      longitude: "73.155",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Thulhaadhoo",
      atoll: "B",
      value: "B_Thulhaadhoo",
      alt_name: null,
      latitude: "5.023055556",
      longitude: "72.83972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ufuligiri",
      atoll: "B",
      value: "B_Ufuligiri",
      alt_name: null,
      latitude: "5.016944444",
      longitude: "72.97027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Un'doodhoo",
      atoll: "B",
      value: "B_Un'doodhoo",
      alt_name: null,
      latitude: "5.274444444",
      longitude: "73.04222222",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Vakkaru",
      atoll: "B",
      value: "B_Vakkaru",
      alt_name: null,
      latitude: "5.133611111",
      longitude: "72.91",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Velavaru",
      atoll: "B",
      value: "B_Velavaru",
      alt_name: null,
      latitude: "5.206666666666667",
      longitude: "72.92055555555557",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Veyofushi",
      atoll: "B",
      value: "B_Veyofushi",
      alt_name: null,
      latitude: "5.228888889",
      longitude: "73.15833333333334",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vinaneiyfaruhuraa",
      atoll: "B",
      value: "B_Vinaneiyfaruhuraa",
      alt_name: null,
      latitude: "5.346111111111111",
      longitude: "73.0786111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Voavah",
      atoll: "B",
      value: "B_Voavah",
      alt_name: null,
      latitude: "5.316666667",
      longitude: "73.0775",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Huraafaru",
      atoll: "B",
      value: "B_Huraafaru",
      alt_name: "Finolhu",
      latitude: "5.206680555555556",
      longitude: "73.15422222222223",
      flags: ["R"],
    },
    {
      type: "Patch Reef (Giri)",
      name: "An'gaafaru",
      atoll: "B",
      value: "B_An'gaafaru",
      alt_name: null,
      latitude: "5.1775",
      longitude: "73.09916666666666",
      flags: ["R"],
    },
    {
      type: "Sand Bank",
      name: "Bathalaa huraa",
      atoll: "B",
      value: "B_Bathalaa huraa",
      alt_name: null,
      latitude: "5.358055555555556",
      longitude: "73.0611111111111",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Vandhuh'maafaru finolhu",
      atoll: "B",
      value: "B_Vandhuh'maafaru finolhu",
      alt_name: null,
      latitude: "5.236111111111112",
      longitude: "73.1913888888889",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Maafusheefinolhu",
      atoll: "B",
      value: "B_Maafusheefinolhu",
      alt_name: null,
      latitude: "5.231111111111111",
      longitude: "73.19166666666668",
      flags: [],
    },
    {
      type: "Sand Bank",
      name: "Finolhufaru",
      atoll: "B",
      value: "B_Finolhufaru",
      alt_name: null,
      latitude: "5.183888888888889",
      longitude: "72.93472222222222",
      flags: ["U"],
    },
  ],
  LH: [
    {
      type: "Islands",
      name: "Aligaa",
      atoll: "LH",
      value: "LH_Aligaa",
      alt_name: null,
      latitude: "5.243888889",
      longitude: "73.51638889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Boamandhipparu huraagan'du",
      atoll: "LH",
      value: "LH_Boamandhipparu huraagan'du",
      alt_name: null,
      latitude: "5.498333333333333",
      longitude: "73.51055555555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "LH",
      value: "LH_Bodufinolhu",
      alt_name: null,
      latitude: "5.269166666666667",
      longitude: "73.57111111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodugaahuraa",
      atoll: "LH",
      value: "LH_Bodugaahuraa",
      alt_name: "Bodufaahuraa",
      latitude: "5.332222222",
      longitude: "73.65722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhashugirifinolhu",
      atoll: "LH",
      value: "LH_Dhashugirifinolhu",
      alt_name: null,
      latitude: "5.421111111111111",
      longitude: "73.42611111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dheruffinolhu",
      atoll: "LH",
      value: "LH_Dheruffinolhu",
      alt_name: null,
      latitude: "5.324166666666667",
      longitude: "73.64722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhihdhoo",
      atoll: "LH",
      value: "LH_Dhihdhoo",
      alt_name: "Ookolhudhihdhoo",
      latitude: "5.376111111",
      longitude: "73.38222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhiffushi",
      atoll: "LH",
      value: "LH_Dhiffushi",
      alt_name: "Dhiffushimaadhoo",
      latitude: "5.386666667",
      longitude: "73.64916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhirun'baahuraa",
      atoll: "LH",
      value: "LH_Dhirun'baahuraa",
      alt_name: null,
      latitude: "5.353888889",
      longitude: "73.65833333",
      flags: [],
    },
    {
      type: "Islands",
      name: "Faadhoo",
      atoll: "LH",
      value: "LH_Faadhoo",
      alt_name: null,
      latitude: "5.431388889",
      longitude: "73.63027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Faadhoohuraagan'du",
      atoll: "LH",
      value: "LH_Faadhoohuraagan'du",
      alt_name: null,
      latitude: "5.435555555555556",
      longitude: "73.61999999999999",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fainu aadhanhuraa",
      atoll: "LH",
      value: "LH_Fainu aadhanhuraa",
      alt_name: null,
      latitude: "5.358333333",
      longitude: "73.65777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fehigili",
      atoll: "LH",
      value: "LH_Fehigili",
      alt_name: null,
      latitude: "5.5575",
      longitude: "73.48138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Felivaru",
      atoll: "LH",
      value: "LH_Felivaru",
      alt_name: null,
      latitude: "5.476944444",
      longitude: "73.38583333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Fushifaru",
      atoll: "LH",
      value: "LH_Fushifaru",
      alt_name: null,
      latitude: "5.490833333",
      longitude: "73.51527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaaerifaru",
      atoll: "LH",
      value: "LH_Gaaerifaru",
      alt_name: null,
      latitude: "5.485",
      longitude: "73.40361111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Govvaafushi",
      atoll: "LH",
      value: "LH_Govvaafushi",
      alt_name: null,
      latitude: "5.357222222222222",
      longitude: "73.65861111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hinnavaru",
      atoll: "LH",
      value: "LH_Hinnavaru",
      alt_name: null,
      latitude: "5.491944444",
      longitude: "73.41222222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hiriyaadhoo",
      atoll: "LH",
      value: "LH_Hiriyaadhoo",
      alt_name: null,
      latitude: "5.4125",
      longitude: "73.64388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hudhufushi",
      atoll: "LH",
      value: "LH_Hudhufushi",
      alt_name: null,
      latitude: "5.361944444",
      longitude: "73.65388889",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Huravalhi",
      atoll: "LH",
      value: "LH_Huravalhi",
      alt_name: null,
      latitude: "5.520833333",
      longitude: "73.44166667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Innahuraa",
      atoll: "LH",
      value: "LH_Innahuraa",
      alt_name: null,
      latitude: "5.350277778",
      longitude: "73.65416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalhumanjehuraa",
      atoll: "LH",
      value: "LH_Kalhumanjehuraa",
      alt_name: null,
      latitude: "5.554444444",
      longitude: "73.48277777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kanifushi",
      atoll: "LH",
      value: "LH_Kanifushi",
      alt_name: null,
      latitude: "5.363888888888889",
      longitude: "73.3325",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kanuhuraa",
      atoll: "LH",
      value: "LH_Kanuhuraa",
      alt_name: null,
      latitude: "5.5325",
      longitude: "73.50638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Komandoo",
      atoll: "LH",
      value: "LH_Komandoo",
      alt_name: null,
      latitude: "5.493333333",
      longitude: "73.42416667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudadhoo",
      atoll: "LH",
      value: "LH_Kudadhoo",
      alt_name: null,
      latitude: "5.5025",
      longitude: "73.43388888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kurehdhoo",
      atoll: "LH",
      value: "LH_Kurehdhoo",
      alt_name: null,
      latitude: "5.549722222",
      longitude: "73.46583333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kurendhoo",
      atoll: "LH",
      value: "LH_Kurendhoo",
      alt_name: null,
      latitude: "5.333888889",
      longitude: "73.46361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Lhohi IND)",
      atoll: "LH",
      value: "LH_Lhohi IND)",
      alt_name: null,
      latitude: "5.321388889",
      longitude: "73.47277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lhossalafushi",
      atoll: "LH",
      value: "LH_Lhossalafushi",
      alt_name: null,
      latitude: "5.3075",
      longitude: "73.48277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maabinhuraaa",
      atoll: "LH",
      value: "LH_Maabinhuraaa",
      alt_name: null,
      latitude: "5.336944444",
      longitude: "73.65194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maafilaafushi",
      atoll: "LH",
      value: "LH_Maafilaafushi",
      alt_name: null,
      latitude: "5.3625",
      longitude: "73.41611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maakoa",
      atoll: "LH",
      value: "LH_Maakoa",
      alt_name: null,
      latitude: "5.357222222",
      longitude: "73.43027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Madhiriguraidhoo",
      atoll: "LH",
      value: "LH_Madhiriguraidhoo",
      alt_name: null,
      latitude: "5.469166667",
      longitude: "73.56",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Madivaru",
      atoll: "LH",
      value: "LH_Madivaru",
      alt_name: null,
      latitude: "5.458888889",
      longitude: "73.37027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maduvvari",
      atoll: "LH",
      value: "LH_Maduvvari",
      alt_name: null,
      latitude: "5.284722222",
      longitude: "73.50194444",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Maidhoo",
      atoll: "LH",
      value: "LH_Maidhoo",
      alt_name: null,
      latitude: "5.3975",
      longitude: "73.64861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mas leggihuraa",
      atoll: "LH",
      value: "LH_Mas leggihuraa",
      alt_name: null,
      latitude: "5.543611111",
      longitude: "73.50083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medha adihuraa",
      atoll: "LH",
      value: "LH_Medha adihuraa",
      alt_name: null,
      latitude: "5.540833333",
      longitude: "73.50277778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Medhafushi",
      atoll: "LH",
      value: "LH_Medhafushi",
      alt_name: null,
      latitude: "5.355555556",
      longitude: "73.42666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meedhaahuraa",
      atoll: "LH",
      value: "LH_Meedhaahuraa",
      alt_name: null,
      latitude: "5.369166666666667",
      longitude: "73.4075",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meyyafushi",
      atoll: "LH",
      value: "LH_Meyyafushi",
      alt_name: null,
      latitude: "5.441111111",
      longitude: "73.60805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Naifaru",
      atoll: "LH",
      value: "LH_Naifaru",
      alt_name: null,
      latitude: "5.444444444",
      longitude: "73.365",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Olhuvelifushi",
      atoll: "LH",
      value: "LH_Olhuvelifushi",
      alt_name: null,
      latitude: "5.278055556",
      longitude: "73.60638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ookolhufinolhu",
      atoll: "LH",
      value: "LH_Ookolhufinolhu",
      alt_name: null,
      latitude: "5.281666667",
      longitude: "73.6225",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Rathuruh-huraa",
      atoll: "LH",
      value: "LH_Rathuruh-huraa",
      alt_name: null,
      latitude: "5.4025",
      longitude: "73.64861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Sehlhifushi",
      atoll: "LH",
      value: "LH_Sehlhifushi",
      alt_name: null,
      latitude: "5.423055555555556",
      longitude: "73.64",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thilamaafushi",
      atoll: "LH",
      value: "LH_Thilamaafushi",
      alt_name: null,
      latitude: "5.273055556",
      longitude: "73.58694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Varihuraa",
      atoll: "LH",
      value: "LH_Varihuraa",
      alt_name: null,
      latitude: "5.303333333",
      longitude: "73.48805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vavvaru",
      atoll: "LH",
      value: "LH_Vavvaru",
      alt_name: null,
      latitude: "5.4175",
      longitude: "73.35416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Veligan'du",
      atoll: "LH",
      value: "LH_Veligan'du",
      alt_name: null,
      latitude: "5.528333333",
      longitude: "73.4375",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Veyvah",
      atoll: "LH",
      value: "LH_Veyvah",
      alt_name: null,
      latitude: "5.426111111111111",
      longitude: "73.36055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vihafarufinolhu",
      atoll: "LH",
      value: "LH_Vihafarufinolhu",
      alt_name: null,
      latitude: "5.455555556",
      longitude: "73.58222222222221",
      flags: ["U"],
    },
  ],
  K: [
    {
      type: "Islands",
      name: "Aarah",
      atoll: "K",
      value: "K_Aarah",
      alt_name: null,
      latitude: "4.23",
      longitude: "73.49444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Akirifushi",
      atoll: "K",
      value: "K_Akirifushi",
      alt_name: null,
      latitude: "4.6375",
      longitude: "73.40055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Asdhoo",
      atoll: "K",
      value: "K_Asdhoo",
      alt_name: null,
      latitude: "4.466111111",
      longitude: "73.66111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Baros",
      atoll: "K",
      value: "K_Baros",
      alt_name: null,
      latitude: "4.284722222",
      longitude: "73.42722222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Biyaadhoo",
      atoll: "K",
      value: "K_Biyaadhoo",
      alt_name: null,
      latitude: "3.921944444",
      longitude: "73.45638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Boduban'dos",
      atoll: "K",
      value: "K_Boduban'dos",
      alt_name: null,
      latitude: "4.269444444",
      longitude: "73.49138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "K",
      value: "K_Bodufinolhu",
      alt_name: null,
      latitude: "3.8575",
      longitude: "73.45638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Boduhithi",
      atoll: "K",
      value: "K_Boduhithi",
      alt_name: null,
      latitude: "4.430277778",
      longitude: "73.38444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Boduhuraa",
      atoll: "K",
      value: "K_Boduhuraa",
      alt_name: null,
      latitude: "3.967222222",
      longitude: "73.50527778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bolifushi",
      atoll: "K",
      value: "K_Bolifushi",
      alt_name: null,
      latitude: "4.095833333",
      longitude: "73.40138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhiffushi",
      atoll: "K",
      value: "K_Dhiffushi",
      alt_name: null,
      latitude: "4.441944444",
      longitude: "73.71361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhigufinolhu",
      atoll: "K",
      value: "K_Dhigufinolhu",
      alt_name: null,
      latitude: "3.972222222",
      longitude: "73.50222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhoonidhoo",
      atoll: "K",
      value: "K_Dhoonidhoo",
      alt_name: null,
      latitude: "4.196944444",
      longitude: "73.51361111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "En'boodhoo",
      atoll: "K",
      value: "K_En'boodhoo",
      alt_name: null,
      latitude: "4.083888889",
      longitude: "73.51194444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "En'boodhoofinolhu",
      atoll: "K",
      value: "K_En'boodhoofinolhu",
      alt_name: null,
      latitude: "4.103055556",
      longitude: "73.52527778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Eriadhoo",
      atoll: "K",
      value: "K_Eriadhoo",
      alt_name: null,
      latitude: "4.59",
      longitude: "73.41444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Erruh-huraa",
      atoll: "K",
      value: "K_Erruh-huraa",
      alt_name: null,
      latitude: "3.814722222",
      longitude: "73.41611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Farukolhufushi",
      atoll: "K",
      value: "K_Farukolhufushi",
      alt_name: null,
      latitude: "4.230833333",
      longitude: "73.54388889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Feydhoofinolhu",
      atoll: "K",
      value: "K_Feydhoofinolhu",
      alt_name: null,
      latitude: "4.2138888888888895",
      longitude: "73.48555555555555",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fihaalhohi",
      atoll: "K",
      value: "K_Fihaalhohi",
      alt_name: null,
      latitude: "3.877222222",
      longitude: "73.36694444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fonadhoo",
      atoll: "K",
      value: "K_Fonadhoo",
      alt_name: null,
      latitude: "4.183611111",
      longitude: "73.51777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Furanafushi",
      atoll: "K",
      value: "K_Furanafushi",
      alt_name: null,
      latitude: "4.249722222",
      longitude: "73.54555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gaafaru",
      atoll: "K",
      value: "K_Gaafaru",
      alt_name: null,
      latitude: "4.735833333",
      longitude: "73.5",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gaagan'du",
      atoll: "K",
      value: "K_Gaagan'du",
      alt_name: "Kudahuraa",
      latitude: "4.249444444",
      longitude: "73.53666667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Gashurifinolhu",
      atoll: "K",
      value: "K_Gashurifinolhu",
      alt_name: null,
      latitude: "4.361111111",
      longitude: "73.62611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Giraavaru",
      atoll: "K",
      value: "K_Giraavaru",
      alt_name: null,
      latitude: "4.200277778",
      longitude: "73.41277778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Girifushi",
      atoll: "K",
      value: "K_Girifushi",
      alt_name: null,
      latitude: "4.318333333",
      longitude: "73.57833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gulhi",
      atoll: "K",
      value: "K_Gulhi",
      alt_name: null,
      latitude: "3.990277778",
      longitude: "73.50888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gulhigaathuhuraa",
      atoll: "K",
      value: "K_Gulhigaathuhuraa",
      alt_name: null,
      latitude: "3.976666667",
      longitude: "73.50638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Guraidhoo",
      atoll: "K",
      value: "K_Guraidhoo",
      alt_name: null,
      latitude: "3.900555556",
      longitude: "73.46805556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Helen'geli",
      atoll: "K",
      value: "K_Helen'geli",
      alt_name: null,
      latitude: "4.634444444",
      longitude: "73.56333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Henbadhoo",
      atoll: "K",
      value: "K_Henbadhoo",
      alt_name: null,
      latitude: "4.481388889",
      longitude: "73.39305556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hinmafushi",
      atoll: "K",
      value: "K_Hinmafushi",
      alt_name: null,
      latitude: "4.308888889",
      longitude: "73.57111111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hulhule H)",
      atoll: "K",
      value: "MaleCity_Hulhule",
      value2: "K_Hulhule H)",
      alt_name: "AIE,",
      latitude: "4.189166667",
      longitude: "73.52916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhumale'",
      atoll: "K",
      value: "MaleCity_Hulhumale",
      value2: "K_Hulhumale'",
      alt_name: null,
      latitude: "4.212222222",
      longitude: "73.54027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Huraa",
      atoll: "K",
      value: "K_Huraa",
      alt_name: null,
      latitude: "4.333611111",
      longitude: "73.60083333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ihuru",
      atoll: "K",
      value: "K_Ihuru",
      alt_name: null,
      latitude: "4.306666667",
      longitude: "73.41583333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kaashidhoo",
      atoll: "K",
      value: "K_Kaashidhoo",
      alt_name: null,
      latitude: "4.955555556",
      longitude: "73.46111111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kagi",
      atoll: "K",
      value: "K_Kagi",
      alt_name: null,
      latitude: "4.676944444",
      longitude: "73.50083333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kalhuhuraa",
      atoll: "K",
      value: "K_Kalhuhuraa",
      alt_name: null,
      latitude: "4.009444444444444",
      longitude: "73.37277777777777",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'doomaafushi",
      atoll: "K",
      value: "K_Kan'doomaafushi",
      alt_name: null,
      latitude: "3.903333333",
      longitude: "73.47333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kan'duoiygiri",
      atoll: "K",
      value: "K_Kan'duoiygiri",
      alt_name: null,
      latitude: "4.257777778",
      longitude: "73.54055556",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kanifinolhu",
      atoll: "K",
      value: "K_Kanifinolhu",
      alt_name: null,
      latitude: "4.343333333",
      longitude: "73.60805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kanuoiyhuraa",
      atoll: "K",
      value: "K_Kanuoiyhuraa",
      alt_name: null,
      latitude: "4.318333333",
      longitude: "73.59166667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kohdhipparu",
      atoll: "K",
      value: "K_Kohdhipparu",
      alt_name: null,
      latitude: "4.260277778",
      longitude: "73.38055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudaban'dos",
      atoll: "K",
      value: "K_Kudaban'dos",
      alt_name: null,
      latitude: "4.263611111",
      longitude: "73.49972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudafinolhu",
      atoll: "K",
      value: "K_Kudafinolhu",
      alt_name: null,
      latitude: "3.865",
      longitude: "73.45833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudahithi",
      atoll: "K",
      value: "K_Kudahithi",
      alt_name: null,
      latitude: "4.416944444",
      longitude: "73.38",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudahuraa",
      atoll: "K",
      value: "K_Kudahuraa",
      alt_name: null,
      latitude: "4.328055555555555",
      longitude: "73.5975",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Lankanfinolhu",
      atoll: "K",
      value: "K_Lankanfinolhu",
      alt_name: null,
      latitude: "4.285",
      longitude: "73.55361111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Lankanfushi",
      atoll: "K",
      value: "K_Lankanfushi",
      alt_name: null,
      latitude: "4.294722222",
      longitude: "73.55805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Lhohifushi",
      atoll: "K",
      value: "K_Lhohifushi",
      alt_name: null,
      latitude: "4.350555556",
      longitude: "73.61805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Lhosfushi",
      atoll: "K",
      value: "K_Lhosfushi",
      alt_name: null,
      latitude: "3.896944444",
      longitude: "73.46972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maadhoo",
      atoll: "K",
      value: "K_Maadhoo",
      alt_name: null,
      latitude: "3.870833333",
      longitude: "73.45861111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maafushi",
      atoll: "K",
      value: "K_Maafushi",
      alt_name: null,
      latitude: "3.940555556",
      longitude: "73.48944444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Madivaru",
      atoll: "K",
      value: "K_Madivaru",
      alt_name: null,
      latitude: "4.500555556",
      longitude: "73.36805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mahaana elhihuraa",
      atoll: "K",
      value: "K_Mahaana elhihuraa",
      alt_name: null,
      latitude: "3.811944444",
      longitude: "73.41138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maifalhuhuraa",
      atoll: "K",
      value: "K_Maifalhuhuraa",
      alt_name: null,
      latitude: "4.63",
      longitude: "73.57055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Makundhoo",
      atoll: "K",
      value: "K_Makundhoo",
      alt_name: null,
      latitude: "4.5425",
      longitude: "73.40555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Makunufushi",
      atoll: "K",
      value: "K_Makunufushi",
      alt_name: null,
      latitude: "3.917777778",
      longitude: "73.46972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Malé",
      atoll: "K",
      value: "MaleCity_Male",
      value2: "K_Malé",
      alt_name: "",
      latitude: "4.174166667",
      longitude: "73.50972222",
      flags: ["I", "H"],
    },
    {
      type: "Islands",
      name: "Maniyafushi [IND]",
      atoll: "K",
      value: "K_Maniyafushi [IND]",
      alt_name: null,
      latitude: "4.055833333",
      longitude: "73.41111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhufinolhu",
      atoll: "K",
      value: "K_Medhufinolhu",
      alt_name: null,
      latitude: "4.513888889",
      longitude: "73.36916667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Meerufenfushi",
      atoll: "K",
      value: "K_Meerufenfushi",
      alt_name: null,
      latitude: "4.453611111",
      longitude: "73.71666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Nakahchaafushi",
      atoll: "K",
      value: "K_Nakahchaafushi",
      alt_name: null,
      latitude: "4.368333333",
      longitude: "73.37",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Olhigan'dufinolhu",
      atoll: "K",
      value: "K_Olhigan'dufinolhu",
      alt_name: null,
      latitude: "3.811666667",
      longitude: "73.41777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Olhuhali",
      atoll: "K",
      value: "K_Olhuhali",
      alt_name: null,
      latitude: "4.689722222",
      longitude: "73.45111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Olhuveli",
      atoll: "K",
      value: "K_Olhuveli",
      alt_name: null,
      latitude: "3.850277778",
      longitude: "73.455",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rannaalhi",
      atoll: "K",
      value: "K_Rannaalhi",
      alt_name: null,
      latitude: "3.903055556",
      longitude: "73.3575",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rasfari",
      atoll: "K",
      value: "K_Rasfari",
      alt_name: null,
      latitude: "4.394444444",
      longitude: "73.35138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Than'burudhoo",
      atoll: "K",
      value: "K_Than'burudhoo",
      alt_name: null,
      latitude: "4.315277778",
      longitude: "73.58416667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Thilafushi",
      atoll: "K",
      value: "K_Thilafushi",
      alt_name: null,
      latitude: "4.183333333",
      longitude: "73.44555556",
      flags: ["IND"],
    },
    {
      type: "Islands",
      name: "Thulhaagiri",
      atoll: "K",
      value: "K_Thulhaagiri",
      alt_name: null,
      latitude: "4.311388889",
      longitude: "73.48722222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Thulusdhoo",
      atoll: "K",
      value: "K_Thulusdhoo",
      alt_name: null,
      latitude: "4.373888889",
      longitude: "73.65083333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Huraagan'du",
      atoll: "K",
      value: "K_Huraagan'du",
      alt_name: null,
      latitude: "4.366111111111111",
      longitude: "73.62222222222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thun'bafushi",
      atoll: "K",
      value: "K_Thun'bafushi",
      alt_name: null,
      latitude: "4.589722222",
      longitude: "73.58972222",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Vaadhoo",
      atoll: "K",
      value: "K_Vaadhoo",
      alt_name: null,
      latitude: "4.123888889",
      longitude: "73.45722222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vaagali",
      atoll: "K",
      value: "K_Vaagali",
      alt_name: null,
      latitude: "3.948333333",
      longitude: "73.35611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vabbinfaru",
      atoll: "K",
      value: "K_Vabbinfaru",
      alt_name: null,
      latitude: "4.309722222",
      longitude: "73.42388889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vabboahuraa",
      atoll: "K",
      value: "K_Vabboahuraa",
      alt_name: "IRD",
      latitude: "4.319166667",
      longitude: "73.59611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vammaafushi",
      atoll: "K",
      value: "K_Vammaafushi",
      alt_name: null,
      latitude: "3.948611111",
      longitude: "73.49611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Velassaru",
      atoll: "K",
      value: "K_Velassaru",
      alt_name: "",
      latitude: "4.121388889",
      longitude: "73.43694444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Veligan'duhuraa",
      atoll: "K",
      value: "K_Veligan'duhuraa",
      alt_name: null,
      latitude: "3.971388889",
      longitude: "73.50638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vihamanaafushi",
      atoll: "K",
      value: "K_Vihamanaafushi",
      alt_name: null,
      latitude: "4.226666667",
      longitude: "73.51972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vilin'gili mathidhahuraa",
      atoll: "K",
      value: "K_Vilin'gili mathidhahuraa",
      alt_name: null,
      latitude: "4.376944444",
      longitude: "73.66277778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vilimale",
      name2: "Vilingili",
      atoll: "K",
      value: "MaleCity_Vilimale",
      value2: "K_Vilingili",
      alt_name: null,
      latitude: "4.173055556",
      longitude: "73.48527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vilivaru",
      atoll: "K",
      value: "K_Vilivaru",
      alt_name: "Viligilivaru",
      latitude: "3.914166667",
      longitude: "73.45555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Ziyaaraiyfushi",
      atoll: "K",
      value: "K_Ziyaaraiyfushi",
      alt_name: null,
      latitude: "4.533055556",
      longitude: "73.37222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Udhafinolhu",
      atoll: "K",
      value: "K_Udhafinolhu",
      alt_name: "Aanugandufinolh",
      latitude: "4.305669444444444",
      longitude: "73.5065861111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhonmaaga",
      atoll: "K",
      value: "K_Dhonmaaga",
      alt_name: null,
      latitude: "3.965527777777778",
      longitude: "73.44966666666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bulhifushi",
      atoll: "K",
      value: "K_Bulhifushi",
      alt_name: null,
      latitude: "3.9798055555555556",
      longitude: "73.50115555555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Funfinolhu",
      atoll: "K",
      value: "K_Funfinolhu",
      alt_name: null,
      latitude: "3.9762833333333334",
      longitude: "73.50487222222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Noofinolhu",
      atoll: "K",
      value: "K_Noofinolhu",
      alt_name: null,
      latitude: "3.9762833333333334",
      longitude: "73.50487222222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Emmafushi",
      atoll: "K",
      value: "K_Emmafushi",
      alt_name: null,
      latitude: "4.1237861111111105",
      longitude: "73.46373333333334",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Akasdhoo",
      atoll: "K",
      value: "K_Akasdhoo",
      alt_name: null,
      latitude: "4.123513888888889",
      longitude: "73.47235",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Aanugan'du huraa",
      atoll: "K",
      value: "K_Aanugan'du huraa",
      alt_name: null,
      latitude: "4.3069444444444445",
      longitude: "73.50108333333333",
      flags: ["R"],
    },
    {
      type: "Knoll (Thila)",
      name: "Tholhimaraa huraa",
      atoll: "K",
      value: "K_Tholhimaraa huraa",
      alt_name: null,
      latitude: "3.8233333333333333",
      longitude: "73.37416666666665",
      flags: ["R"],
    },
    {
      type: "Lagoon (Falhu)",
      name: "Dhonfushi",
      atoll: "K",
      value: "K_Dhonfushi",
      alt_name: null,
      latitude: "4.608888888888888",
      longitude: "73.40777777777778",
      flags: ["R"],
    },
    {
      type: "Lagoon (Falhu)",
      name: "Kanbaashaa",
      atoll: "K",
      value: "K_Kanbaashaa",
      alt_name: null,
      latitude: "4.621744444444445",
      longitude: "73.39487777777778",
      flags: ["R"],
    },
    {
      type: "Lagoon (Falhu)",
      name: "Nashvilu",
      atoll: "K",
      value: "K_Nashvilu",
      alt_name: null,
      latitude: "4.624611111111111",
      longitude: "73.40643333333334",
      flags: ["R"],
    },
    {
      type: "Lagoon (Falhu)",
      name: "Hastheem",
      atoll: "K",
      value: "K_Hastheem",
      alt_name: null,
      latitude: "4.623055555555556",
      longitude: "73.4113888888889",
      flags: ["R"],
    },
    {
      type: "Lagoon (Falhu)",
      name: "Maaranfushi",
      atoll: "K",
      value: "K_Maaranfushi",
      alt_name: null,
      latitude: "4.609505555555555",
      longitude: "73.41890000000001",
      flags: ["R"],
    },
    {
      type: "Sand Bank",
      name: "Bodubis",
      atoll: "K",
      value: "K_Bodubis",
      alt_name: null,
      latitude: "4.275555555555555",
      longitude: "73.41472222222222",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Kudabis",
      atoll: "K",
      value: "K_Kudabis",
      alt_name: null,
      latitude: "4.2716666666666665",
      longitude: "73.38194444444444",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Kohdhipparu finolhu",
      atoll: "K",
      value: "K_Kohdhipparu finolhu",
      alt_name: null,
      latitude: "4.248888888888889",
      longitude: "73.37805555555555",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Ithaafinolhu",
      atoll: "K",
      value: "K_Ithaafinolhu",
      alt_name: null,
      latitude: "4.000244444444444",
      longitude: "73.39164166666667",
      flags: [],
    },
  ],
  AA: [
    {
      type: "Islands",
      name: "Alikoirah",
      atoll: "AA",
      value: "AA_Alikoirah",
      alt_name: null,
      latitude: "3.943333333",
      longitude: "72.88027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bathalaa",
      atoll: "AA",
      value: "AA_Bathalaa",
      alt_name: null,
      latitude: "4.070277778",
      longitude: "72.94527778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodufolhudhoo",
      atoll: "AA",
      value: "AA_Bodufolhudhoo",
      alt_name: null,
      latitude: "4.185277778",
      longitude: "72.77305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ellaidhoo",
      atoll: "AA",
      value: "AA_Ellaidhoo",
      alt_name: null,
      latitude: "4.006111111",
      longitude: "72.94888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Etheremadivaru",
      atoll: "AA",
      value: "AA_Etheremadivaru",
      alt_name: null,
      latitude: "4.118611111",
      longitude: "72.93777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Feridhoo",
      atoll: "AA",
      value: "AA_Feridhoo",
      alt_name: null,
      latitude: "4.050833333",
      longitude: "72.72527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fesdhoo",
      atoll: "AA",
      value: "AA_Fesdhoo",
      alt_name: null,
      latitude: "4.006666667",
      longitude: "72.81083333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fusfinolhu",
      atoll: "AA",
      value: "AA_Fusfinolhu",
      alt_name: null,
      latitude: "4.018333333",
      longitude: "72.95833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fushi",
      atoll: "AA",
      value: "AA_Fushi",
      alt_name: null,
      latitude: "4.2155555555555555",
      longitude: "72.88361111111112",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaagan'du",
      atoll: "AA",
      value: "AA_Gaagan'du",
      alt_name: null,
      latitude: "4.232777777777778",
      longitude: "72.865",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaathafushi",
      atoll: "AA",
      value: "AA_Gaathafushi",
      alt_name: null,
      latitude: "4.023333333",
      longitude: "72.81055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gangehi",
      atoll: "AA",
      value: "AA_Gangehi",
      alt_name: null,
      latitude: "4.22",
      longitude: "72.755",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Halaveli",
      atoll: "AA",
      value: "AA_Halaveli",
      alt_name: null,
      latitude: "4.038055556",
      longitude: "72.91916667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Himendhoo",
      atoll: "AA",
      value: "AA_Himendhoo",
      alt_name: null,
      latitude: "3.920833333",
      longitude: "72.74388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kan'dholhudoo",
      atoll: "AA",
      value: "AA_Kan'dholhudoo",
      alt_name: null,
      latitude: "4.0025",
      longitude: "72.88138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudafolhudhoo",
      atoll: "AA",
      value: "AA_Kudafolhudhoo",
      alt_name: null,
      latitude: "4.181111111",
      longitude: "72.76694444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kuramathi",
      atoll: "AA",
      value: "AA_Kuramathi",
      alt_name: null,
      latitude: "4.259166667",
      longitude: "72.97916667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maagau",
      atoll: "AA",
      value: "AA_Maagau",
      alt_name: null,
      latitude: "3.988888889",
      longitude: "72.95694444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maalhos",
      atoll: "AA",
      value: "AA_Maalhos",
      alt_name: null,
      latitude: "3.986944444",
      longitude: "72.71972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maayafushi",
      atoll: "AA",
      value: "AA_Maayafushi",
      alt_name: null,
      latitude: "4.073611111",
      longitude: "72.8875",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Madivaru",
      atoll: "AA",
      value: "AA_Madivaru",
      alt_name: null,
      latitude: "4.265277778",
      longitude: "73",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Madivarufinolhu",
      atoll: "AA",
      value: "AA_Madivarufinolhu",
      alt_name: null,
      latitude: "4.268611111111111",
      longitude: "73",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Madoogali",
      atoll: "AA",
      value: "AA_Madoogali",
      alt_name: null,
      latitude: "4.095833333",
      longitude: "72.75277778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mathivereefinolhu",
      atoll: "AA",
      value: "AA_Mathivereefinolhu",
      alt_name: null,
      latitude: "4.185",
      longitude: "72.75055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mathiveri",
      atoll: "AA",
      value: "AA_Mathiveri",
      alt_name: null,
      latitude: "4.191666667",
      longitude: "72.74611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mushimasmigili",
      atoll: "AA",
      value: "AA_Mushimasmigili",
      alt_name: null,
      latitude: "3.958888889",
      longitude: "72.91305556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rasdhoo",
      atoll: "AA",
      value: "AA_Rasdhoo",
      alt_name: null,
      latitude: "4.262777778",
      longitude: "72.99194444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thoddoo",
      atoll: "AA",
      value: "AA_Thoddoo",
      alt_name: null,
      latitude: "4.438888888888889",
      longitude: "72.95861111111111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ukulhas",
      atoll: "AA",
      value: "AA_Ukulhas",
      alt_name: "",
      latitude: "4.214722222",
      longitude: "72.86388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Velidhoo",
      atoll: "AA",
      value: "AA_Velidhoo",
      alt_name: null,
      latitude: "4.194722222",
      longitude: "72.81833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Veligan'du",
      atoll: "AA",
      value: "AA_Veligan'du",
      alt_name: null,
      latitude: "4.298888889",
      longitude: "73.01138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vihamaafaru",
      atoll: "AA",
      value: "AA_Vihamaafaru",
      alt_name: null,
      latitude: "4.121944444",
      longitude: "72.74638889",
      flags: ["U", "IND"],
    },
    {
      type: "Sand Bank",
      name: "Dhinnolhufinolhu",
      atoll: "AA",
      value: "AA_Dhinnolhufinolhu",
      alt_name: null,
      latitude: "4.138333333333334",
      longitude: "72.73305555555555",
      flags: ["U"],
    },
  ],
  ADH: [
    {
      type: "Islands",
      name: "Angaagau",
      atoll: "ADH",
      value: "ADH_Angaagau",
      alt_name: null,
      latitude: "3.6525",
      longitude: "72.82166667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Ariyadhoo",
      atoll: "ADH",
      value: "ADH_Ariyadhoo",
      alt_name: null,
      latitude: "3.475",
      longitude: "72.85472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Athurugau",
      atoll: "ADH",
      value: "ADH_Athurugau",
      alt_name: null,
      latitude: "3.886944444",
      longitude: "72.81611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "ADH",
      value: "ADH_Bodufinolhu",
      alt_name: null,
      latitude: "3.4941666666666666",
      longitude: "72.7611111111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodukaashihuraa",
      atoll: "ADH",
      value: "ADH_Bodukaashihuraa",
      alt_name: null,
      latitude: "3.875833333",
      longitude: "72.95472222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bulhalohi",
      atoll: "ADH",
      value: "ADH_Bulhalohi",
      alt_name: "Bulhalafushi",
      latitude: "3.738888889",
      longitude: "72.73166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhan'gethi",
      atoll: "ADH",
      value: "ADH_Dhan'gethi",
      alt_name: null,
      latitude: "3.6075",
      longitude: "72.95527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhihdhoo",
      atoll: "ADH",
      value: "ADH_Dhihdhoo",
      alt_name: null,
      latitude: "3.4830555555555556",
      longitude: "72.8775",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhihdhoofinolhu",
      atoll: "ADH",
      value: "ADH_Dhihdhoofinolhu",
      alt_name: null,
      latitude: "3.498333333",
      longitude: "72.89611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhiffushi",
      atoll: "ADH",
      value: "ADH_Dhiffushi",
      alt_name: null,
      latitude: "3.475",
      longitude: "72.82472222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhiggiri",
      atoll: "ADH",
      value: "ADH_Dhiggiri",
      alt_name: null,
      latitude: "3.858611111",
      longitude: "72.915",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigurah",
      atoll: "ADH",
      value: "ADH_Dhigurah",
      alt_name: null,
      latitude: "3.530555556",
      longitude: "72.92583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "En'boodhoo",
      atoll: "ADH",
      value: "ADH_En'boodhoo",
      alt_name: null,
      latitude: "3.815",
      longitude: "72.75222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenfushi",
      atoll: "ADH",
      value: "ADH_Fenfushi",
      alt_name: null,
      latitude: "3.489166667",
      longitude: "72.78361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hangnaameedhoo",
      atoll: "ADH",
      value: "ADH_Hangnaameedhoo",
      alt_name: null,
      latitude: "3.849166667",
      longitude: "72.955",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Heenfaru",
      atoll: "ADH",
      value: "ADH_Heenfaru",
      alt_name: null,
      latitude: "3.819444444444444",
      longitude: "72.8286111111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hiyafushi",
      atoll: "ADH",
      value: "ADH_Hiyafushi",
      alt_name: null,
      latitude: "3.479166667",
      longitude: "72.87027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hukurudhoo",
      atoll: "ADH",
      value: "ADH_Hukurudhoo",
      alt_name: null,
      latitude: "3.570277778",
      longitude: "72.71861111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Hurasdhoo",
      atoll: "ADH",
      value: "ADH_Hurasdhoo",
      alt_name: null,
      latitude: "3.666666667",
      longitude: "72.77472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Huruelhi",
      atoll: "ADH",
      value: "ADH_Huruelhi",
      alt_name: null,
      latitude: "3.543888889",
      longitude: "72.71944444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Huvahendhoo",
      atoll: "ADH",
      value: "ADH_Huvahendhoo",
      alt_name: null,
      latitude: "3.653611111",
      longitude: "72.95361111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Innafushi",
      atoll: "ADH",
      value: "ADH_Innafushi",
      alt_name: null,
      latitude: "3.797222222",
      longitude: "72.73222222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kalhahan'dhihuraa",
      atoll: "ADH",
      value: "ADH_Kalhahan'dhihuraa",
      alt_name: null,
      latitude: "3.798055556",
      longitude: "72.71055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudadhoo",
      atoll: "ADH",
      value: "ADH_Kudadhoo",
      alt_name: null,
      latitude: "3.478888889",
      longitude: "72.87194444444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudarah",
      atoll: "ADH",
      value: "ADH_Kudarah",
      alt_name: null,
      latitude: "3.573888889",
      longitude: "72.91055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kun'burudhoo",
      atoll: "ADH",
      value: "ADH_Kun'burudhoo",
      alt_name: null,
      latitude: "3.775555556",
      longitude: "72.925",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Lonuboi",
      atoll: "ADH",
      value: "ADH_Lonuboi",
      alt_name: null,
      latitude: "3.603055556",
      longitude: "72.90055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maafushivaru",
      atoll: "ADH",
      value: "ADH_Maafushivaru",
      alt_name: null,
      latitude: "3.607777778",
      longitude: "72.90027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maamin'gili [ADF]",
      atoll: "ADH",
      value: "ADH_Maamin'gili [ADF]",
      alt_name: null,
      latitude: "3.476111111",
      longitude: "72.83666667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Machchafushi",
      atoll: "ADH",
      value: "ADH_Machchafushi",
      alt_name: null,
      latitude: "3.593611111",
      longitude: "72.88333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mahibadhoo",
      atoll: "ADH",
      value: "ADH_Mahibadhoo",
      alt_name: null,
      latitude: "3.756944444",
      longitude: "72.96916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mandhoo",
      atoll: "ADH",
      value: "ADH_Mandhoo",
      alt_name: null,
      latitude: "3.697777778",
      longitude: "72.70944444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mirihi",
      atoll: "ADH",
      value: "ADH_Mirihi",
      alt_name: null,
      latitude: "3.619166667",
      longitude: "72.78027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Moofushi",
      atoll: "ADH",
      value: "ADH_Moofushi",
      alt_name: null,
      latitude: "3.884722222",
      longitude: "72.72777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Nalaguraidhoo",
      atoll: "ADH",
      value: "ADH_Nalaguraidhoo",
      alt_name: null,
      latitude: "3.483333333",
      longitude: "72.80138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Omadhoo",
      atoll: "ADH",
      value: "ADH_Omadhoo",
      alt_name: null,
      latitude: "3.791388889",
      longitude: "72.96194444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Rangaleefinolhu",
      atoll: "ADH",
      value: "ADH_Rangaleefinolhu",
      alt_name: null,
      latitude: "3.616111111",
      longitude: "72.71638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rangali",
      atoll: "ADH",
      value: "ADH_Rangali",
      alt_name: "",
      latitude: "3.617777778",
      longitude: "72.72305556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Theluveligaa",
      atoll: "ADH",
      value: "ADH_Theluveligaa",
      alt_name: null,
      latitude: "3.67",
      longitude: "72.9025",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Tholhifushi",
      atoll: "ADH",
      value: "ADH_Tholhifushi",
      alt_name: null,
      latitude: "3.484722222",
      longitude: "72.79",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Thun'dufushi",
      atoll: "ADH",
      value: "ADH_Thun'dufushi",
      alt_name: null,
      latitude: "3.786111111",
      longitude: "72.73083333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vakarufalhi",
      atoll: "ADH",
      value: "ADH_Vakarufalhi",
      alt_name: null,
      latitude: "3.578333333",
      longitude: "72.90194444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vilamendhoo",
      atoll: "ADH",
      value: "ADH_Vilamendhoo",
      alt_name: null,
      latitude: "3.633611111",
      longitude: "72.95888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vilin'gilivaru",
      atoll: "ADH",
      value: "ADH_Vilin'gilivaru",
      alt_name: null,
      latitude: "3.618888889",
      longitude: "72.955",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rahdhiggaa",
      atoll: "ADH",
      value: "ADH_Rahdhiggaa",
      alt_name: null,
      latitude: "3.7575",
      longitude: "72.77083333333333",
      flags: ["R"],
    },
    {
      type: "Sand Bank",
      name: "Finolhu",
      atoll: "ADH",
      value: "ADH_Finolhu",
      alt_name: "Aafinolhu",
      latitude: "3.555555556",
      longitude: "72.86805556",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Athulivaru finolhu",
      atoll: "ADH",
      value: "ADH_Athulivaru finolhu",
      alt_name: null,
      latitude: "3.647972222222222",
      longitude: "72.95573055555556",
      flags: ["U"],
    },
  ],
  V: [
    {
      type: "Islands",
      name: "Aarah",
      atoll: "V",
      value: "V_Aarah",
      alt_name: null,
      latitude: "3.499166667",
      longitude: "73.52916667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Alimathaa",
      atoll: "V",
      value: "V_Alimathaa",
      alt_name: null,
      latitude: "3.593611111",
      longitude: "73.49777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Anbaraa",
      atoll: "V",
      value: "V_Anbaraa",
      alt_name: null,
      latitude: "3.372222222",
      longitude: "73.43944444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodumohoraa",
      atoll: "V",
      value: "V_Bodumohoraa",
      alt_name: null,
      latitude: "3.343055556",
      longitude: "73.52111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhiggiri",
      atoll: "V",
      value: "V_Dhiggiri",
      alt_name: null,
      latitude: "3.645",
      longitude: "73.48722222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Felidhoo",
      atoll: "V",
      value: "V_Felidhoo",
      alt_name: null,
      latitude: "3.471666667",
      longitude: "73.54722222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fohtheyobodufushi",
      atoll: "V",
      value: "V_Fohtheyobodufushi",
      alt_name: null,
      latitude: "3.454722222",
      longitude: "73.75833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fulidhoo",
      atoll: "V",
      value: "V_Fulidhoo",
      alt_name: null,
      latitude: "3.680277778",
      longitude: "73.41583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hin'gaakulheefinolhu",
      atoll: "V",
      value: "V_Hin'gaakulheefinolhu",
      alt_name: null,
      latitude: "3.358333333",
      longitude: "73.58277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhidhoo",
      atoll: "V",
      value: "V_Hulhidhoo",
      alt_name: null,
      latitude: "3.493333333",
      longitude: "73.53277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Keyodhoo",
      atoll: "V",
      value: "V_Keyodhoo",
      alt_name: null,
      latitude: "3.461944444",
      longitude: "73.55",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kuda anbaraa",
      atoll: "V",
      value: "V_Kuda anbaraa",
      alt_name: null,
      latitude: "3.426944444",
      longitude: "73.42472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kunaavashi",
      atoll: "V",
      value: "V_Kunaavashi",
      alt_name: null,
      latitude: "3.636388889",
      longitude: "73.36472222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rakeedhoo",
      atoll: "V",
      value: "V_Rakeedhoo",
      alt_name: null,
      latitude: "3.314722222",
      longitude: "73.46972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ruh hurihuraa",
      atoll: "V",
      value: "V_Ruh hurihuraa",
      alt_name: null,
      latitude: "3.361111111",
      longitude: "73.5",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thinadhoo",
      atoll: "V",
      value: "V_Thinadhoo",
      alt_name: null,
      latitude: "3.4875",
      longitude: "73.53805556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thun'duhuraa",
      atoll: "V",
      value: "V_Thun'duhuraa",
      alt_name: null,
      latitude: "3.3425000000000002",
      longitude: "73.5062638888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vashugiri",
      atoll: "V",
      value: "V_Vashugiri",
      alt_name: null,
      latitude: "3.630277778",
      longitude: "73.3775",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vattaru",
      atoll: "V",
      value: "V_Vattaru",
      alt_name: null,
      latitude: "3.221111111",
      longitude: "73.42638889",
      flags: ["U"],
    },
    {
      type: "Knoll (Thila)",
      name: "Rah'gandu",
      atoll: "V",
      value: "V_Rah'gandu",
      alt_name: null,
      latitude: "3.4097222222222223",
      longitude: "73.38710555555556",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Hurahufinolhu",
      atoll: "V",
      value: "V_Hurahufinolhu",
      alt_name: null,
      latitude: "3.481666666666667",
      longitude: "73.70361111111112",
      flags: ["U"],
    },
  ],
  M: [
    {
      type: "Islands",
      name: "Boahuraa",
      atoll: "M",
      value: "M_Boahuraa",
      alt_name: null,
      latitude: "2.925833333",
      longitude: "73.58555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhekunuboduveli",
      atoll: "M",
      value: "M_Dhekunuboduveli",
      alt_name: null,
      latitude: "2.825277778",
      longitude: "73.45194444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhiggaru",
      atoll: "M",
      value: "M_Dhiggaru",
      alt_name: null,
      latitude: "3.111666667",
      longitude: "73.56555556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhihthun'di",
      atoll: "M",
      value: "M_Dhihthun'di",
      alt_name: null,
      latitude: "2.765833333",
      longitude: "73.42111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Erruh-huraa",
      atoll: "M",
      value: "M_Erruh-huraa",
      alt_name: null,
      latitude: "3.069722222",
      longitude: "73.64194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenfuraaveli",
      atoll: "M",
      value: "M_Fenfuraaveli",
      alt_name: null,
      latitude: "2.788611111111111",
      longitude: "73.42750000000001",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Gaakurali",
      atoll: "M",
      value: "M_Gaakurali",
      alt_name: null,
      latitude: "2.78",
      longitude: "73.37222222",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Gasveli",
      atoll: "M",
      value: "M_Gasveli",
      alt_name: null,
      latitude: "2.83",
      longitude: "73.45833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gongalihuraa",
      atoll: "M",
      value: "M_Gongalihuraa",
      alt_name: null,
      latitude: "2.853888889",
      longitude: "73.55083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hakuraahuraa",
      atoll: "M",
      value: "M_Hakuraahuraa",
      alt_name: null,
      latitude: "2.853888889",
      longitude: "73.53861111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hudhuveli",
      atoll: "M",
      value: "M_Hudhuveli",
      alt_name: null,
      latitude: "3.036666667",
      longitude: "73.61944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hurasveli",
      atoll: "M",
      value: "M_Hurasveli",
      alt_name: null,
      latitude: "3.018888889",
      longitude: "73.61805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kekuraalhuveli",
      atoll: "M",
      value: "M_Kekuraalhuveli",
      alt_name: null,
      latitude: "2.851944444",
      longitude: "73.53472222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kolhufushi",
      atoll: "M",
      value: "M_Kolhufushi",
      alt_name: "",
      latitude: "2.779722222",
      longitude: "73.42527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kuda usfushi",
      atoll: "M",
      value: "M_Kuda usfushi",
      alt_name: null,
      latitude: "2.818333333",
      longitude: "73.44361111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kuradhigan'du",
      atoll: "M",
      value: "M_Kuradhigan'du",
      alt_name: null,
      latitude: "2.773888889",
      longitude: "73.3725",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maa usfushi",
      atoll: "M",
      value: "M_Maa usfushi",
      alt_name: null,
      latitude: "2.803888889",
      longitude: "73.43361111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maahuraa",
      atoll: "M",
      value: "M_Maahuraa",
      alt_name: null,
      latitude: "2.7930555555555556",
      longitude: "73.42833333333334",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maalhaveli",
      atoll: "M",
      value: "M_Maalhaveli",
      alt_name: null,
      latitude: "2.904444444",
      longitude: "73.57888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Madifushi",
      atoll: "M",
      value: "M_Madifushi",
      alt_name: null,
      latitude: "3.0811111111111114",
      longitude: "73.63944444444445",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maduvvari",
      atoll: "M",
      value: "M_Maduvvari",
      alt_name: null,
      latitude: "3.105",
      longitude: "73.57277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Medhufushi",
      atoll: "M",
      value: "M_Medhufushi",
      alt_name: null,
      latitude: "2.886111111",
      longitude: "73.57555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mulah",
      atoll: "M",
      value: "M_Mulah",
      alt_name: null,
      latitude: "2.946666667",
      longitude: "73.58472222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Muli",
      atoll: "M",
      value: "M_Muli",
      alt_name: null,
      latitude: "2.920833333",
      longitude: "73.58111111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Naalaafushi",
      atoll: "M",
      value: "M_Naalaafushi",
      alt_name: null,
      latitude: "2.895",
      longitude: "73.57722222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Raaban'dhihuraa",
      atoll: "M",
      value: "M_Raaban'dhihuraa",
      alt_name: "Fenboafinolhu",
      latitude: "3.091944444",
      longitude: "73.38861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Raiymandhoo",
      atoll: "M",
      value: "M_Raiymandhoo",
      alt_name: null,
      latitude: "3.089722222",
      longitude: "73.63888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Seedheehuraa",
      atoll: "M",
      value: "M_Seedheehuraa",
      alt_name: null,
      latitude: "2.857777778",
      longitude: "73.55777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Seedheehuraa veligan'du",
      atoll: "M",
      value: "M_Seedheehuraa veligan'du",
      alt_name: null,
      latitude: "2.859444444",
      longitude: "73.55416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thuvaru",
      atoll: "M",
      value: "M_Thuvaru",
      alt_name: null,
      latitude: "2.898055556",
      longitude: "73.37916667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Uthuruboduveli",
      atoll: "M",
      value: "M_Uthuruboduveli",
      alt_name: null,
      latitude: "3.025277778",
      longitude: "73.61833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Uthurugaseveli",
      atoll: "M",
      value: "M_Uthurugaseveli",
      alt_name: null,
      latitude: "3.031111111",
      longitude: "73.61888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Veyvah",
      atoll: "M",
      value: "M_Veyvah",
      alt_name: null,
      latitude: "2.956111111",
      longitude: "73.6",
      flags: ["I"],
    },
  ],
  F: [
    {
      type: "Islands",
      name: "Adhangau",
      atoll: "F",
      value: "F_Adhangau",
      alt_name: null,
      latitude: "3.138888889",
      longitude: "73.00833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bileiydhoo",
      atoll: "F",
      value: "F_Bileiydhoo",
      alt_name: null,
      latitude: "3.118055556",
      longitude: "72.98416667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dharan'boodhoo",
      atoll: "F",
      value: "F_Dharan'boodhoo",
      alt_name: null,
      latitude: "3.062777778",
      longitude: "72.92611111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhiguvarufinolhu",
      atoll: "F",
      value: "F_Dhiguvarufinolhu",
      alt_name: null,
      latitude: "3.246666667",
      longitude: "73.02527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "En'bulufushi",
      atoll: "F",
      value: "F_En'bulufushi",
      alt_name: null,
      latitude: "3.134444444",
      longitude: "73.01833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Faanumaahuraa",
      atoll: "F",
      value: "F_Faanumaahuraa",
      alt_name: null,
      latitude: "3.213333333",
      longitude: "72.98194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Feeali",
      atoll: "F",
      value: "F_Feeali",
      alt_name: null,
      latitude: "3.269722222",
      longitude: "73.00222222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Filitheyo",
      atoll: "F",
      value: "F_Filitheyo",
      alt_name: null,
      latitude: "3.213055556",
      longitude: "73.03694444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Himithi",
      atoll: "F",
      value: "F_Himithi",
      alt_name: null,
      latitude: "3.254722222222222",
      longitude: "72.81916666666666",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Jinnathugau",
      atoll: "F",
      value: "F_Jinnathugau",
      alt_name: null,
      latitude: "3.200277778",
      longitude: "72.99805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'dumoonufushi",
      atoll: "F",
      value: "F_Kan'dumoonufushi",
      alt_name: null,
      latitude: "3.315833333",
      longitude: "72.89777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maafushi",
      atoll: "F",
      value: "F_Maafushi",
      alt_name: null,
      latitude: "3.243333333",
      longitude: "72.97861111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Madivaruhuraa",
      atoll: "F",
      value: "F_Madivaruhuraa",
      alt_name: null,
      latitude: "3.266666667",
      longitude: "73.01055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Magoodhoo",
      atoll: "F",
      value: "F_Magoodhoo",
      alt_name: null,
      latitude: "3.078333333",
      longitude: "72.96388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Magoodhoo bodufinolhu",
      atoll: "F",
      value: "F_Magoodhoo bodufinolhu",
      alt_name: null,
      latitude: "3.073888888888889",
      longitude: "72.95416666666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Makunueri",
      atoll: "F",
      value: "F_Makunueri",
      alt_name: null,
      latitude: "3.258333333",
      longitude: "72.92861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Minimasgali",
      atoll: "F",
      value: "F_Minimasgali",
      alt_name: null,
      latitude: "3.242777778",
      longitude: "72.83555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Nilandhoo",
      atoll: "F",
      value: "F_Nilandhoo",
      alt_name: null,
      latitude: "3.055833333",
      longitude: "72.88944444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vilin'gilvarufinolhu",
      atoll: "F",
      value: "F_Vilin'gilvarufinolhu",
      alt_name: null,
      latitude: "3.274166667",
      longitude: "72.99861111",
      flags: ["U"],
    },
  ],
  DH: [
    {
      type: "Islands",
      name: "Aluvifushi",
      atoll: "DH",
      value: "DH_Aluvifushi",
      alt_name: null,
      latitude: "2.932777778",
      longitude: "72.96055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ayyakaloahuraa",
      atoll: "DH",
      value: "DH_Ayyakaloahuraa",
      alt_name: null,
      latitude: "2.793888889",
      longitude: "73.02555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ban'didhoo",
      atoll: "DH",
      value: "DH_Ban'didhoo",
      alt_name: null,
      latitude: "2.936388889",
      longitude: "72.99027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Bulhalafushi",
      atoll: "DH",
      value: "DH_Bulhalafushi",
      alt_name: null,
      latitude: "2.806388889",
      longitude: "73.02611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhebaidhoo",
      atoll: "DH",
      value: "DH_Dhebaidhoo",
      alt_name: null,
      latitude: "2.790555556",
      longitude: "73.02555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhoores",
      atoll: "DH",
      value: "DH_Dhoores",
      alt_name: null,
      latitude: "2.917222222",
      longitude: "72.88388889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "En'boodhoofushi",
      atoll: "DH",
      value: "DH_En'boodhoofushi",
      alt_name: null,
      latitude: "2.6775",
      longitude: "72.92777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Faandhoo",
      atoll: "DH",
      value: "DH_Faandhoo",
      alt_name: null,
      latitude: "2.9625",
      longitude: "72.94638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fenfushi",
      atoll: "DH",
      value: "DH_Fenfushi",
      alt_name: null,
      latitude: "2.803611111",
      longitude: "73.02611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenmeeruhuraa",
      atoll: "DH",
      value: "DH_Fenmeeruhuraa",
      alt_name: null,
      latitude: "2.787222222",
      longitude: "73.02527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gemendhoo",
      atoll: "DH",
      value: "DH_Gemendhoo",
      alt_name: null,
      latitude: "2.801111111",
      longitude: "73.02583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hiriyafushi",
      atoll: "DH",
      value: "DH_Hiriyafushi",
      alt_name: null,
      latitude: "2.711666667",
      longitude: "72.98777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hudhufusheefinolhu",
      atoll: "DH",
      value: "DH_Hudhufusheefinolhu",
      alt_name: null,
      latitude: "2.893611111",
      longitude: "72.90472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhudheli",
      atoll: "DH",
      value: "DH_Hulhudheli",
      alt_name: null,
      latitude: "2.858333333",
      longitude: "72.84583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hulhuvehi",
      atoll: "DH",
      value: "DH_Hulhuvehi",
      alt_name: null,
      latitude: "2.856388889",
      longitude: "73.025",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Issari",
      atoll: "DH",
      value: "DH_Issari",
      alt_name: null,
      latitude: "2.706388889",
      longitude: "72.9825",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'dinmaa",
      atoll: "DH",
      value: "DH_Kan'dinmaa",
      alt_name: null,
      latitude: "2.7325",
      longitude: "73.01138888888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kanneiyfaru",
      atoll: "DH",
      value: "DH_Kanneiyfaru",
      alt_name: null,
      latitude: "2.923888889",
      longitude: "73.02694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kedhigan'du",
      atoll: "DH",
      value: "DH_Kedhigan'du",
      alt_name: null,
      latitude: "2.695833333",
      longitude: "72.85138889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kiraidhoo",
      atoll: "DH",
      value: "DH_Kiraidhoo",
      alt_name: null,
      latitude: "2.780277778",
      longitude: "73.025",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudahuvadhoo H)",
      atoll: "DH",
      value: "DH_Kudahuvadhoo H)",
      alt_name: "ADF,",
      latitude: "2.671111111",
      longitude: "72.89388889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Lhohi",
      atoll: "DH",
      value: "DH_Lhohi",
      alt_name: null,
      latitude: "2.956944444",
      longitude: "72.98555556",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Maadheli",
      atoll: "DH",
      value: "DH_Maadheli",
      alt_name: null,
      latitude: "2.884166667",
      longitude: "72.83722222",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Maaen'boodhoo",
      atoll: "DH",
      value: "DH_Maaen'boodhoo",
      alt_name: null,
      latitude: "2.695555556",
      longitude: "72.96305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maafushi",
      atoll: "DH",
      value: "DH_Maafushi",
      alt_name: null,
      latitude: "2.688055556",
      longitude: "72.85916667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maagau",
      atoll: "DH",
      value: "DH_Maagau",
      alt_name: null,
      latitude: "2.947777778",
      longitude: "72.91416667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maalefaru",
      atoll: "DH",
      value: "DH_Maalefaru",
      alt_name: null,
      latitude: "2.8819444444444446",
      longitude: "73.02555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meedhoo",
      atoll: "DH",
      value: "DH_Meedhoo",
      alt_name: null,
      latitude: "2.998055556",
      longitude: "73.00638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Meedhuffushi",
      atoll: "DH",
      value: "DH_Meedhuffushi",
      alt_name: null,
      latitude: "3.003333333",
      longitude: "73.00055556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Minimasgali",
      atoll: "DH",
      value: "DH_Minimasgali",
      alt_name: null,
      latitude: "2.750277778",
      longitude: "72.88722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhufushi",
      atoll: "DH",
      value: "DH_Olhufushi",
      alt_name: null,
      latitude: "2.813611111",
      longitude: "73.02638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhuveli",
      atoll: "DH",
      value: "DH_Olhuveli",
      alt_name: null,
      latitude: "2.681944444",
      longitude: "72.93416667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rin'budhoo",
      atoll: "DH",
      value: "DH_Rin'budhoo",
      alt_name: null,
      latitude: "2.924166667",
      longitude: "72.89527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thaban'lhaidhoo",
      atoll: "DH",
      value: "DH_Thaban'lhaidhoo",
      alt_name: null,
      latitude: "2.797777778",
      longitude: "73.02527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thilabolhufushi",
      atoll: "DH",
      value: "DH_Thilabolhufushi",
      alt_name: null,
      latitude: "2.755277778",
      longitude: "73.02222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thinhuraa",
      atoll: "DH",
      value: "DH_Thinhuraa",
      alt_name: null,
      latitude: "2.766666667",
      longitude: "73.02388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Uhdhoo",
      atoll: "DH",
      value: "DH_Uhdhoo",
      alt_name: null,
      latitude: "2.970277778",
      longitude: "72.99055556",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Vaanee",
      atoll: "DH",
      value: "DH_Vaanee",
      alt_name: null,
      latitude: "2.725277778",
      longitude: "73.00277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Valla",
      atoll: "DH",
      value: "DH_Valla",
      alt_name: null,
      latitude: "2.704444444",
      longitude: "72.8825",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vallalhohi",
      atoll: "DH",
      value: "DH_Vallalhohi",
      alt_name: null,
      latitude: "2.730555556",
      longitude: "72.88777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Velavaru",
      atoll: "DH",
      value: "DH_Velavaru",
      alt_name: null,
      latitude: "2.979722222",
      longitude: "73.01555556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vommuli",
      atoll: "DH",
      value: "DH_Vommuli",
      alt_name: null,
      latitude: "2.911388889",
      longitude: "72.86583333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Angalhaidhoo",
      atoll: "DH",
      value: "DH_Angalhaidhoo",
      alt_name: null,
      latitude: "2.7416666666666667",
      longitude: "73.01861111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Aarah",
      atoll: "DH",
      value: "DH_Aarah",
      alt_name: "Sarakafushi",
      latitude: "2.9227777777777777",
      longitude: "72.96111111111111",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Boarikifinolhu",
      atoll: "DH",
      value: "DH_Boarikifinolhu",
      alt_name: null,
      latitude: "2.923294444444444",
      longitude: "72.97113055555556",
      flags: [],
    },
  ],
  TH: [
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "TH",
      value: "TH_Bodufinolhu",
      alt_name: null,
      latitude: "2.315555556",
      longitude: "73.30527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodurehaa",
      atoll: "TH",
      value: "TH_Bodurehaa",
      alt_name: null,
      latitude: "2.2675",
      longitude: "73.22916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Burunee",
      atoll: "TH",
      value: "TH_Burunee",
      alt_name: null,
      latitude: "2.558888889",
      longitude: "73.10666667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhiffushi",
      atoll: "TH",
      value: "TH_Dhiffushi",
      alt_name: null,
      latitude: "2.515",
      longitude: "73.23222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhiyamigili",
      atoll: "TH",
      value: "TH_Dhiyamigili",
      alt_name: null,
      latitude: "2.339166667",
      longitude: "73.33694444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhonanfushi",
      atoll: "TH",
      value: "TH_Dhonanfushi",
      alt_name: null,
      latitude: "2.489722222",
      longitude: "73.31472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhururehaa",
      atoll: "TH",
      value: "TH_Dhururehaa",
      alt_name: null,
      latitude: "2.168611111",
      longitude: "73.01194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ekuruffushi",
      atoll: "TH",
      value: "TH_Ekuruffushi",
      alt_name: null,
      latitude: "2.265555556",
      longitude: "73.22638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Elaa",
      atoll: "TH",
      value: "TH_Elaa",
      alt_name: null,
      latitude: "2.171111111",
      longitude: "73.07972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fenfushi",
      atoll: "TH",
      value: "TH_Fenfushi",
      alt_name: null,
      latitude: "2.291388889",
      longitude: "73.26972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenmeerufushi",
      atoll: "TH",
      value: "TH_Fenmeerufushi",
      alt_name: null,
      latitude: "2.270555556",
      longitude: "73.23305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fondhoo",
      atoll: "TH",
      value: "TH_Fondhoo",
      alt_name: null,
      latitude: "2.314722222222222",
      longitude: "72.98277777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fonidhaani",
      atoll: "TH",
      value: "TH_Fonidhaani",
      alt_name: null,
      latitude: "2.300833333",
      longitude: "73.28472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Funaddu",
      atoll: "TH",
      value: "TH_Funaddu",
      alt_name: null,
      latitude: "2.198055556",
      longitude: "73.12861111",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Fushi",
      atoll: "TH",
      value: "TH_Fushi",
      alt_name: "Van'badhifushi",
      latitude: "2.192777778",
      longitude: "72.96861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaadhiffushi",
      atoll: "TH",
      value: "TH_Gaadhiffushi",
      alt_name: null,
      latitude: "2.252222222",
      longitude: "73.21277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gaalee",
      atoll: "TH",
      value: "TH_Gaalee",
      alt_name: null,
      latitude: "2.5475",
      longitude: "73.15416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaathurehaa",
      atoll: "TH",
      value: "TH_Gaathurehaa",
      alt_name: null,
      latitude: "2.170277778",
      longitude: "73.01555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Guraidhoo",
      atoll: "TH",
      value: "TH_Guraidhoo",
      alt_name: null,
      latitude: "2.325",
      longitude: "73.31916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hathifushi",
      atoll: "TH",
      value: "TH_Hathifushi",
      alt_name: null,
      latitude: "2.287222222",
      longitude: "73.26305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hikan'dhihohi",
      atoll: "TH",
      value: "TH_Hikan'dhihohi",
      alt_name: null,
      latitude: "2.520555556",
      longitude: "73.22666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hirilandhoo",
      atoll: "TH",
      value: "TH_Hirilandhoo",
      alt_name: null,
      latitude: "2.270833333",
      longitude: "72.93166667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hiriyanfushi",
      atoll: "TH",
      value: "TH_Hiriyanfushi",
      alt_name: null,
      latitude: "2.211666667",
      longitude: "73.14944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hon'delifushi",
      atoll: "TH",
      value: "TH_Hon'delifushi",
      alt_name: null,
      latitude: "2.494722222",
      longitude: "73.3125",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhiyanfushi",
      atoll: "TH",
      value: "TH_Hulhiyanfushi",
      alt_name: null,
      latitude: "2.258611111",
      longitude: "73.21805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaaddoo",
      atoll: "TH",
      value: "TH_Kaaddoo",
      alt_name: null,
      latitude: "2.281666667",
      longitude: "73.25444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kafidhoo",
      atoll: "TH",
      value: "TH_Kafidhoo",
      alt_name: null,
      latitude: "2.326944444",
      longitude: "72.96166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kakolhas",
      atoll: "TH",
      value: "TH_Kakolhas",
      alt_name: null,
      latitude: "2.315277778",
      longitude: "72.94388889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kalhufahalafushi",
      atoll: "TH",
      value: "TH_Kalhufahalafushi",
      alt_name: null,
      latitude: "2.406388889",
      longitude: "73.36055555555555",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Kan'doodhoo",
      atoll: "TH",
      value: "TH_Kan'doodhoo",
      alt_name: null,
      latitude: "2.320833333",
      longitude: "72.91638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kan'dufushi",
      atoll: "TH",
      value: "TH_Kan'dufushi",
      alt_name: null,
      latitude: "2.531388889",
      longitude: "72.9875",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kani",
      atoll: "TH",
      value: "TH_Kani",
      alt_name: null,
      latitude: "2.189444444",
      longitude: "72.97333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kanimeedhoo",
      atoll: "TH",
      value: "TH_Kanimeedhoo",
      alt_name: null,
      latitude: "2.195",
      longitude: "73.11138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kin'bidhoo",
      atoll: "TH",
      value: "TH_Kin'bidhoo",
      alt_name: null,
      latitude: "2.168055556",
      longitude: "73.06583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kolafushi",
      atoll: "TH",
      value: "TH_Kolafushi",
      alt_name: null,
      latitude: "2.263888889",
      longitude: "73.22333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kolhufushi",
      atoll: "TH",
      value: "TH_Kolhufushi",
      alt_name: null,
      latitude: "2.364722222",
      longitude: "73.36333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudadhoo",
      atoll: "TH",
      value: "TH_Kudadhoo",
      alt_name: null,
      latitude: "2.308888889",
      longitude: "72.95138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudakaaddoo",
      atoll: "TH",
      value: "TH_Kudakaaddoo",
      alt_name: null,
      latitude: "2.285277778",
      longitude: "73.25916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudakin'bidhoo",
      atoll: "TH",
      value: "TH_Kudakin'bidhoo",
      alt_name: null,
      latitude: "2.164166667",
      longitude: "73.06277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kuran'dhuvaru",
      atoll: "TH",
      value: "TH_Kuran'dhuvaru",
      alt_name: null,
      latitude: "2.539166667",
      longitude: "73.17583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kuredhifushi",
      atoll: "TH",
      value: "TH_Kuredhifushi",
      alt_name: null,
      latitude: "2.1675",
      longitude: "73.03388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lhavaddoo",
      atoll: "TH",
      value: "TH_Lhavaddoo",
      alt_name: null,
      latitude: "2.305555556",
      longitude: "73.29111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maagulhi",
      atoll: "TH",
      value: "TH_Maagulhi",
      alt_name: null,
      latitude: "2.538055556",
      longitude: "73.17944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maalefushi",
      atoll: "TH",
      value: "TH_Maalefushi",
      alt_name: null,
      latitude: "2.310277778",
      longitude: "73.29805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Madifushi",
      atoll: "TH",
      value: "TH_Madifushi",
      alt_name: null,
      latitude: "2.356666667",
      longitude: "73.35472222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mathidhoo",
      atoll: "TH",
      value: "TH_Mathidhoo",
      alt_name: null,
      latitude: "2.346111111",
      longitude: "73.34277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhafushi",
      atoll: "TH",
      value: "TH_Medhafushi",
      alt_name: null,
      latitude: "2.343055556",
      longitude: "73.34083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhudhiyafushi",
      atoll: "TH",
      value: "TH_Olhudhiyafushi",
      alt_name: null,
      latitude: "2.271944444",
      longitude: "73.23583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhufushi",
      atoll: "TH",
      value: "TH_Olhufushi",
      alt_name: null,
      latitude: "2.365833333",
      longitude: "72.90861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhufushifinolhu",
      atoll: "TH",
      value: "TH_Olhufushifinolhu",
      alt_name: null,
      latitude: "2.371388889",
      longitude: "72.90833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhugiri",
      atoll: "TH",
      value: "TH_Olhugiri",
      alt_name: null,
      latitude: "2.505833333",
      longitude: "73.25611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Omadhoo",
      atoll: "TH",
      value: "TH_Omadhoo",
      alt_name: null,
      latitude: "2.1675",
      longitude: "73.02361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Rihaamaafushi",
      atoll: "TH",
      value: "TH_Rihaamaafushi",
      alt_name: null,
      latitude: "2.289166667",
      longitude: "73.26638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ruhthibirah",
      atoll: "TH",
      value: "TH_Ruhthibirah",
      alt_name: null,
      latitude: "2.168055556",
      longitude: "73.05277778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Thimarafushi [ADF,H]",
      atoll: "TH",
      value: "TH_Thimarafushi [ADF,H]",
      alt_name: null,
      latitude: "2.205555556",
      longitude: "73.14277778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Ufuriyaa",
      atoll: "TH",
      value: "TH_Ufuriyaa",
      alt_name: null,
      latitude: "2.361111111",
      longitude: "73.36166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Usfushi",
      atoll: "TH",
      value: "TH_Usfushi",
      alt_name: null,
      latitude: "2.246111111",
      longitude: "73.20444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vanbadhi",
      atoll: "TH",
      value: "TH_Vanbadhi",
      alt_name: null,
      latitude: "2.186944444",
      longitude: "72.97555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vandhoo",
      atoll: "TH",
      value: "TH_Vandhoo",
      alt_name: null,
      latitude: "2.291388889",
      longitude: "72.94166667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Veymandoo",
      atoll: "TH",
      value: "TH_Veymandoo",
      alt_name: null,
      latitude: "2.186666667",
      longitude: "73.095",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vilufushi",
      atoll: "TH",
      value: "TH_Vilufushi",
      alt_name: null,
      latitude: "2.503055556",
      longitude: "73.30833333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kalhudheyfushi",
      atoll: "TH",
      value: "TH_Kalhudheyfushi",
      alt_name: null,
      latitude: "2.2944444444444443",
      longitude: "73.27666666666667",
      flags: ["R"],
    },
  ],
  L: [
    {
      type: "Islands",
      name: "Aarahaa",
      atoll: "L",
      value: "L_Aarahaa",
      alt_name: null,
      latitude: "1.828888889",
      longitude: "73.27444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Athahendha",
      atoll: "L",
      value: "L_Athahendha",
      alt_name: null,
      latitude: "1.8280555555555555",
      longitude: "73.27388888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Baresdhoo",
      atoll: "L",
      value: "L_Baresdhoo",
      alt_name: null,
      latitude: "1.967777778",
      longitude: "73.53972222",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodu mungnafushi",
      atoll: "L",
      value: "L_Bodu mungnafushi",
      alt_name: null,
      latitude: "1.988888889",
      longitude: "73.30833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodufenrahaa",
      atoll: "L",
      value: "L_Bodufenrahaa",
      alt_name: null,
      latitude: "1.8275",
      longitude: "73.27111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "L",
      value: "L_Bodufinolhu",
      alt_name: null,
      latitude: "1.945",
      longitude: "73.54027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Boduhuraa falhuthere)",
      atoll: "L",
      value: "L_Boduhuraa falhuthere)",
      alt_name: "Maavashu",
      latitude: "1.800555556",
      longitude: "73.29444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodumaabulhali",
      atoll: "L",
      value: "L_Bodumaabulhali",
      alt_name: null,
      latitude: "1.849166667",
      longitude: "73.25555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodumahigulhi",
      atoll: "L",
      value: "L_Bodumahigulhi",
      alt_name: null,
      latitude: "1.786666667",
      longitude: "73.32611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bokaiyfushi",
      atoll: "L",
      value: "L_Bokaiyfushi",
      alt_name: null,
      latitude: "1.998611111",
      longitude: "73.53472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Burrahaa",
      atoll: "L",
      value: "L_Burrahaa",
      alt_name: null,
      latitude: "1.826944444",
      longitude: "73.27777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhan'bidhoo",
      atoll: "L",
      value: "L_Dhan'bidhoo",
      alt_name: null,
      latitude: "2.094444444",
      longitude: "73.545",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhonberahaa",
      atoll: "L",
      value: "L_Dhonberahaa",
      alt_name: null,
      latitude: "2.071111111",
      longitude: "73.53583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Enberahaa",
      atoll: "L",
      value: "L_Enberahaa",
      alt_name: null,
      latitude: "1.841944444",
      longitude: "73.2575",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fares",
      atoll: "L",
      value: "L_Fares",
      alt_name: null,
      latitude: "1.799722222",
      longitude: "73.30083333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Fenboarahaa",
      atoll: "L",
      value: "L_Fenboarahaa",
      alt_name: null,
      latitude: "1.81",
      longitude: "73.28555555555555",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenboahuraa",
      atoll: "L",
      value: "L_Fenboahuraa",
      alt_name: "falhuthereU",
      latitude: "2.064166667",
      longitude: "73.53805556",
      flags: [],
    },
    {
      type: "Islands",
      name: "Fonadhoo",
      atoll: "L",
      value: "L_Fonadhoo",
      alt_name: null,
      latitude: "1.833333333",
      longitude: "73.50055556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Fonagaadhoo",
      atoll: "L",
      value: "L_Fonagaadhoo",
      alt_name: null,
      latitude: "2.115277778",
      longitude: "73.54222222",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Fushi",
      atoll: "L",
      value: "L_Fushi",
      alt_name: null,
      latitude: "2.049444444",
      longitude: "73.53194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gaadhoo",
      atoll: "L",
      value: "L_Gaadhoo",
      alt_name: null,
      latitude: "1.820555556",
      longitude: "73.45111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gan",
      atoll: "L",
      value: "L_Gan",
      alt_name: null,
      latitude: "1.918611111",
      longitude: "73.54194444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gahagan'dufinolhu",
      atoll: "L",
      value: "L_Gahagan'dufinolhu",
      alt_name: null,
      latitude: "1.951944444",
      longitude: "73.54",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Guraidhoo",
      atoll: "L",
      value: "L_Guraidhoo",
      alt_name: null,
      latitude: "1.907777778",
      longitude: "73.25472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Haiythoshi",
      atoll: "L",
      value: "L_Haiythoshi",
      alt_name: null,
      latitude: "1.841944444",
      longitude: "73.25833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hanhushi",
      atoll: "L",
      value: "L_Hanhushi",
      alt_name: null,
      latitude: "1.951388889",
      longitude: "73.26166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hendha",
      atoll: "L",
      value: "L_Hendha",
      alt_name: null,
      latitude: "1.821944444",
      longitude: "73.27416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hikan'dhirahaa",
      atoll: "L",
      value: "L_Hikan'dhirahaa",
      alt_name: null,
      latitude: "2.058055556",
      longitude: "73.53638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hithadhoo",
      atoll: "L",
      value: "L_Hithadhoo",
      alt_name: null,
      latitude: "1.796944444",
      longitude: "73.38833333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Holhurahaa",
      atoll: "L",
      value: "L_Holhurahaa",
      alt_name: null,
      latitude: "2.068333333",
      longitude: "73.53888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhimendhoo",
      atoll: "L",
      value: "L_Hulhimendhoo",
      alt_name: null,
      latitude: "1.821944444",
      longitude: "73.39444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhiyandhoo",
      atoll: "L",
      value: "L_Hulhiyandhoo",
      alt_name: null,
      latitude: "2.080555556",
      longitude: "73.54138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhisdhoo",
      atoll: "L",
      value: "L_Hulhisdhoo",
      alt_name: null,
      latitude: "1.785",
      longitude: "73.3875",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boduhuraa falhuthere)",
      atoll: "L",
      value: "L_Boduhuraa falhuthere)",
      alt_name: "Fonadhoo",
      latitude: "1.844166667",
      longitude: "73.51555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Isdhoo",
      atoll: "L",
      value: "L_Isdhoo",
      alt_name: null,
      latitude: "2.118333333",
      longitude: "73.56722222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kahdhoo H)",
      atoll: "L",
      value: "L_Kahdhoo H)",
      alt_name: "ADE,",
      latitude: "1.859722222",
      longitude: "73.52138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalhaidhoo",
      atoll: "L",
      value: "L_Kalhaidhoo",
      alt_name: null,
      latitude: "1.987777778",
      longitude: "73.53666667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kalhurahaa",
      atoll: "L",
      value: "L_Kalhurahaa",
      alt_name: null,
      latitude: "1.844444444",
      longitude: "73.25666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kandaru",
      atoll: "L",
      value: "L_Kandaru",
      alt_name: null,
      latitude: "2.060555556",
      longitude: "73.53638889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kanuhuraa",
      atoll: "L",
      value: "L_Kanuhuraa",
      alt_name: null,
      latitude: "2.045555556",
      longitude: "73.53222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kashidhoo",
      atoll: "L",
      value: "L_Kashidhoo",
      alt_name: null,
      latitude: "1.919166667",
      longitude: "73.25333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kokurahaa",
      atoll: "L",
      value: "L_Kokurahaa",
      alt_name: null,
      latitude: "1.854166667",
      longitude: "73.25472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kuda munyafushi",
      atoll: "L",
      value: "L_Kuda munyafushi",
      alt_name: null,
      latitude: "1.991388889",
      longitude: "73.3125",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudafares",
      atoll: "L",
      value: "L_Kudafares",
      alt_name: null,
      latitude: "1.796666667",
      longitude: "73.30027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudafenrehaa",
      atoll: "L",
      value: "L_Kudafenrehaa",
      alt_name: null,
      latitude: "1.809444444",
      longitude: "73.28888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudafushi",
      atoll: "L",
      value: "L_Kudafushi",
      alt_name: null,
      latitude: "1.788611111",
      longitude: "73.33194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudamaabulhali",
      atoll: "L",
      value: "L_Kudamaabulhali",
      alt_name: null,
      latitude: "1.847222222",
      longitude: "73.25277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudarah",
      atoll: "L",
      value: "L_Kudarah",
      alt_name: null,
      latitude: "2.064722222",
      longitude: "73.53666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudaveshi",
      atoll: "L",
      value: "L_Kudaveshi",
      alt_name: null,
      latitude: "1.824444444",
      longitude: "73.28194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kunahandhoo",
      atoll: "L",
      value: "L_Kunahandhoo",
      alt_name: null,
      latitude: "1.782777778",
      longitude: "73.36805556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kuredhirehaa",
      atoll: "L",
      value: "L_Kuredhirehaa",
      alt_name: null,
      latitude: "1.780555556",
      longitude: "73.35361111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maabaidhoo",
      atoll: "L",
      value: "L_Maabaidhoo",
      alt_name: null,
      latitude: "2.028888889",
      longitude: "73.5325",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maafushi",
      atoll: "L",
      value: "L_Maafushi",
      alt_name: null,
      latitude: "1.791666667",
      longitude: "73.33333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maakalhuveli",
      atoll: "L",
      value: "L_Maakalhuveli",
      alt_name: null,
      latitude: "1.788888889",
      longitude: "73.34",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maamendhoo",
      atoll: "L",
      value: "L_Maamendhoo",
      alt_name: null,
      latitude: "1.816944444",
      longitude: "73.38944444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maandhoo",
      atoll: "L",
      value: "L_Maandhoo",
      alt_name: "",
      latitude: "1.873611111",
      longitude: "73.52805556",
      flags: ["IND", "U"],
    },
    {
      type: "Islands",
      name: "Maavah",
      atoll: "L",
      value: "L_Maavah",
      alt_name: null,
      latitude: "1.885555556",
      longitude: "73.24305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maaveshi",
      atoll: "L",
      value: "L_Maaveshi",
      alt_name: null,
      latitude: "1.833055556",
      longitude: "73.27138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mahakanfushi",
      atoll: "L",
      value: "L_Mahakanfushi",
      alt_name: null,
      latitude: "1.958888889",
      longitude: "73.54027778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Medhu vinagan'du",
      atoll: "L",
      value: "L_Medhu vinagan'du",
      alt_name: null,
      latitude: "1.816666667",
      longitude: "73.27777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mendhoo",
      atoll: "L",
      value: "L_Mendhoo",
      alt_name: null,
      latitude: "1.786666667",
      longitude: "73.38138889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Mundoo",
      atoll: "L",
      value: "L_Mundoo",
      alt_name: null,
      latitude: "2.011944444",
      longitude: "73.53416667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Olhutholhu",
      atoll: "L",
      value: "L_Olhutholhu",
      alt_name: null,
      latitude: "1.788055556",
      longitude: "73.35166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhuveli",
      atoll: "L",
      value: "L_Olhuveli",
      alt_name: null,
      latitude: "1.8158333333333334",
      longitude: "73.4063888888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Rahaa",
      atoll: "L",
      value: "L_Rahaa",
      alt_name: null,
      latitude: "2.055555556",
      longitude: "73.53444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thathunrahaa",
      atoll: "L",
      value: "L_Thathunrahaa",
      alt_name: null,
      latitude: "1.830833333",
      longitude: "73.26833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thun'buri",
      atoll: "L",
      value: "L_Thun'buri",
      alt_name: null,
      latitude: "2.074722222",
      longitude: "73.54",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Uthuru vinagan'du",
      atoll: "L",
      value: "L_Uthuru vinagan'du",
      alt_name: null,
      latitude: "1.817777778",
      longitude: "73.27777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Uvadhevifushi",
      atoll: "L",
      value: "L_Uvadhevifushi",
      alt_name: null,
      latitude: "1.978888889",
      longitude: "73.53694444",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Vadinolhu",
      atoll: "L",
      value: "L_Vadinolhu",
      alt_name: null,
      latitude: "2.0175",
      longitude: "73.35888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Veligan'dufinolhu",
      atoll: "L",
      value: "L_Veligan'dufinolhu",
      alt_name: null,
      latitude: "1.829166667",
      longitude: "73.40805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhekunuvinagan'du",
      atoll: "L",
      value: "L_Dhekunuvinagan'du",
      alt_name: null,
      latitude: "1.8175",
      longitude: "73.27916667",
      flags: ["U"],
    },
  ],
  GA: [
    {
      type: "Islands",
      name: "Araigaththaa",
      atoll: "GA",
      value: "GA_Araigaththaa",
      alt_name: null,
      latitude: "0.451944444",
      longitude: "73.535",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Baavanadhoo",
      atoll: "GA",
      value: "GA_Baavanadhoo",
      alt_name: null,
      latitude: "0.521388889",
      longitude: "73.53972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bakeththaa",
      atoll: "GA",
      value: "GA_Bakeththaa",
      alt_name: null,
      latitude: "0.380833333",
      longitude: "73.49777778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Beyrumauddoo",
      atoll: "GA",
      value: "GA_Beyrumauddoo",
      alt_name: null,
      latitude: "0.794722222",
      longitude: "73.225",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bihurehaa",
      atoll: "GA",
      value: "GA_Bihurehaa",
      alt_name: null,
      latitude: "0.421944444",
      longitude: "73.57083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boadduvaa",
      atoll: "GA",
      value: "GA_Boadduvaa",
      alt_name: "BoaddooU",
      latitude: "0.705833333",
      longitude: "73.33055556",
      flags: [],
    },
    {
      type: "Islands",
      name: "Bodufuttaa",
      atoll: "GA",
      value: "GA_Bodufuttaa",
      alt_name: "Bodehutta",
      latitude: "0.8547222222222222",
      longitude: "73.40305555555557",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodubon'deyyaa",
      atoll: "GA",
      value: "GA_Bodubon'deyyaa",
      alt_name: null,
      latitude: "0.409722222",
      longitude: "73.5675",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodufinolhu",
      atoll: "GA",
      value: "GA_Bodufinolhu",
      alt_name: null,
      latitude: "0.801388889",
      longitude: "73.42305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boduhuraa",
      atoll: "GA",
      value: "GA_Boduhuraa",
      alt_name: null,
      latitude: "0.412222222",
      longitude: "73.57166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhaandhoo",
      atoll: "GA",
      value: "GA_Dhaandhoo",
      alt_name: null,
      latitude: "0.620833333",
      longitude: "73.46194444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhevvaamaagala",
      atoll: "GA",
      value: "GA_Dhevvaamaagala",
      alt_name: null,
      latitude: "0.570833333",
      longitude: "73.19166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhevvadhoo",
      atoll: "GA",
      value: "GA_Dhevvadhoo",
      alt_name: null,
      latitude: "0.556944444",
      longitude: "73.24222222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Dhevvalaabadhoo",
      atoll: "GA",
      value: "GA_Dhevvalaabadhoo",
      alt_name: null,
      latitude: "0.604444444",
      longitude: "73.30944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigudhoo",
      atoll: "GA",
      value: "GA_Dhigudhoo",
      alt_name: null,
      latitude: "0.542777778",
      longitude: "73.53444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigurah",
      atoll: "GA",
      value: "GA_Dhigurah",
      alt_name: null,
      latitude: "0.689722222",
      longitude: "73.44111111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Dhiyadhoo",
      atoll: "GA",
      value: "GA_Dhiyadhoo",
      alt_name: null,
      latitude: "0.478333333",
      longitude: "73.55694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Falhumaafushi",
      atoll: "GA",
      value: "GA_Falhumaafushi",
      alt_name: null,
      latitude: "0.671388889",
      longitude: "73.43833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Falhuverrahaa",
      atoll: "GA",
      value: "GA_Falhuverrahaa",
      alt_name: null,
      latitude: "0.762777778",
      longitude: "73.43472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fulhadhoo",
      atoll: "GA",
      value: "GA_Fulhadhoo",
      alt_name: "Faruhullhehdhoo",
      latitude: "0.8741666666666666",
      longitude: "73.25555555555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenehutta",
      atoll: "GA",
      value: "GA_Fenehutta",
      alt_name: null,
      latitude: "0.713888889",
      longitude: "73.285",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fulan'gi",
      atoll: "GA",
      value: "GA_Fulan'gi",
      alt_name: null,
      latitude: "0.684444444",
      longitude: "73.20194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Funadhoo",
      atoll: "GA",
      value: "GA_Funadhoo",
      alt_name: null,
      latitude: "0.562222222",
      longitude: "73.52583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Funadhooviligillaa",
      atoll: "GA",
      value: "GA_Funadhooviligillaa",
      alt_name: null,
      latitude: "0.569444444",
      longitude: "73.52",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Funamauddaa",
      atoll: "GA",
      value: "GA_Funamauddaa",
      alt_name: "Funamauddoo",
      latitude: "0.533611111",
      longitude: "73.19",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Galandhoo",
      atoll: "GA",
      value: "GA_Galandhoo",
      alt_name: "Galamedhuvaa",
      latitude: "0.53",
      longitude: "73.53694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gemanafushi",
      atoll: "GA",
      value: "GA_Gemanafushi",
      alt_name: null,
      latitude: "0.4425",
      longitude: "73.56833333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Han'dahaa",
      atoll: "GA",
      value: "GA_Han'dahaa",
      alt_name: null,
      latitude: "0.505277778",
      longitude: "73.45388889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hinaamaagalaa",
      atoll: "GA",
      value: "GA_Hinaamaagalaa",
      alt_name: null,
      latitude: "0.629444444",
      longitude: "73.34527778",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hirihuttaa",
      atoll: "GA",
      value: "GA_Hirihuttaa",
      alt_name: "Hirufushi",
      latitude: "0.540277778",
      longitude: "73.34611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hithaadhoo",
      atoll: "GA",
      value: "GA_Hithaadhoo",
      alt_name: null,
      latitude: "0.848611111",
      longitude: "73.24222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hithaadhoogalaa",
      atoll: "GA",
      value: "GA_Hithaadhoogalaa",
      alt_name: null,
      latitude: "0.826111111",
      longitude: "73.25194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhimendhoo",
      atoll: "GA",
      value: "GA_Hulhimendhoo",
      alt_name: null,
      latitude: "0.703333333",
      longitude: "73.44",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hurendhoo",
      atoll: "GA",
      value: "GA_Hurendhoo",
      alt_name: null,
      latitude: "0.846666667",
      longitude: "73.2075",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Idhimaa",
      atoll: "GA",
      value: "GA_Idhimaa",
      alt_name: null,
      latitude: "0.4075",
      longitude: "73.56972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Innarehaa",
      atoll: "GA",
      value: "GA_Innarehaa",
      alt_name: null,
      latitude: "0.379444444",
      longitude: "73.55638889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalhehuttaa",
      atoll: "GA",
      value: "GA_Kalhehuttaa",
      alt_name: null,
      latitude: "0.848333333",
      longitude: "73.17861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaludirehaa",
      atoll: "GA",
      value: "GA_Kaludirehaa",
      alt_name: null,
      latitude: "0.434166667",
      longitude: "73.56916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'duhulhudhoo",
      atoll: "GA",
      value: "GA_Kan'duhulhudhoo",
      alt_name: null,
      latitude: "0.350833333",
      longitude: "73.53972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kan'duvilin'gili",
      atoll: "GA",
      value: "GA_Kan'duvilin'gili",
      alt_name: null,
      latitude: "0.866111111",
      longitude: "73.19027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kendheraa",
      atoll: "GA",
      value: "GA_Kendheraa",
      alt_name: null,
      latitude: "0.726666667",
      longitude: "73.285",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kerehdhoo",
      atoll: "GA",
      value: "GA_Kerehdhoo",
      alt_name: null,
      latitude: "0.658611111",
      longitude: "73.43861111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kisserahaa",
      atoll: "GA",
      value: "GA_Kisserahaa",
      alt_name: null,
      latitude: "0.649722222",
      longitude: "73.13527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodagehuttaa",
      atoll: "GA",
      value: "GA_Kodagehuttaa",
      alt_name: null,
      latitude: "0.8408333333333333",
      longitude: "73.18111111111112",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodahuttaa",
      atoll: "GA",
      value: "GA_Kodahuttaa",
      alt_name: null,
      latitude: "0.6775",
      longitude: "73.43916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodeymatheelaabadhoo",
      atoll: "GA",
      value: "GA_Kodeymatheelaabadhoo",
      alt_name: null,
      latitude: "0.505555556",
      longitude: "73.49833333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kodeyvilin'gili",
      atoll: "GA",
      value: "GA_Kodeyvilin'gili",
      alt_name: null,
      latitude: "0.513333333",
      longitude: "73.54222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kolamaafushi",
      atoll: "GA",
      value: "GA_Kolamaafushi",
      alt_name: null,
      latitude: "0.837777778",
      longitude: "73.18416667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kon'dey",
      atoll: "GA",
      value: "GA_Kon'dey",
      alt_name: null,
      latitude: "0.498611111",
      longitude: "73.54888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kooddoo",
      atoll: "GA",
      value: "GA_Kooddoo",
      alt_name: null,
      latitude: "0.733055556",
      longitude: "73.43333333",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kudalafari",
      atoll: "GA",
      value: "GA_Kudalafari",
      alt_name: null,
      latitude: "0.8966666666666666",
      longitude: "73.34972222222221",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lhossaa",
      atoll: "GA",
      value: "GA_Lhossaa",
      alt_name: null,
      latitude: "0.819722222",
      longitude: "73.20166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hagevilla",
      atoll: "GA",
      value: "GA_Hagevilla",
      alt_name: null,
      latitude: "0.688333333",
      longitude: "73.26666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maafehelaa",
      atoll: "GA",
      value: "GA_Maafehelaa",
      alt_name: null,
      latitude: "0.3794444444444444",
      longitude: "73.55277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maagihuttaa",
      atoll: "GA",
      value: "GA_Maagihuttaa",
      alt_name: "maagefutta",
      latitude: "0.845555556",
      longitude: "73.17944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maakanaarataa",
      atoll: "GA",
      value: "GA_Maakanaarataa",
      alt_name: null,
      latitude: "0.811944444",
      longitude: "73.20694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maamendhoo",
      atoll: "GA",
      value: "GA_Maamendhoo",
      alt_name: null,
      latitude: "0.713888889",
      longitude: "73.43916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maamutaa",
      atoll: "GA",
      value: "GA_Maamutaa",
      alt_name: null,
      latitude: "0.846111111",
      longitude: "73.40805556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maarandhoo",
      atoll: "GA",
      value: "GA_Maarandhoo",
      alt_name: null,
      latitude: "0.853611111",
      longitude: "73.20916667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maarehaa",
      atoll: "GA",
      value: "GA_Maarehaa",
      alt_name: null,
      latitude: "0.461388889",
      longitude: "73.56388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mahahdhoo",
      atoll: "GA",
      value: "GA_Mahahdhoo",
      alt_name: null,
      latitude: "0.583888889",
      longitude: "73.51305556",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mahthidhoo",
      atoll: "GA",
      value: "GA_Mahthidhoo",
      alt_name: "Kodafutta",
      latitude: "0.669444444",
      longitude: "73.36777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mahthurehaa",
      atoll: "GA",
      value: "GA_Mahthurehaa",
      alt_name: null,
      latitude: "0.368333333",
      longitude: "73.55277778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maanaagalaa",
      atoll: "GA",
      value: "GA_Maanaagalaa",
      alt_name: null,
      latitude: "0.8852777777777777",
      longitude: "73.33611111111111",
      flags: [],
    },
    {
      type: "Islands",
      name: "Medharehaa",
      atoll: "GA",
      value: "GA_Medharehaa",
      alt_name: null,
      latitude: "0.363333333",
      longitude: "73.54527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhehuttaa",
      atoll: "GA",
      value: "GA_Medhehuttaa",
      alt_name: null,
      latitude: "0.466666667",
      longitude: "73.56166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Medhuburiyaa",
      atoll: "GA",
      value: "GA_Medhuburiyaa",
      alt_name: null,
      latitude: "0.3725",
      longitude: "73.55333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Melaimu",
      atoll: "GA",
      value: "GA_Melaimu",
      alt_name: "Melaimaa",
      latitude: "0.8575",
      longitude: "73.17916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meradhoo",
      atoll: "GA",
      value: "GA_Meradhoo",
      alt_name: null,
      latitude: "0.586666667",
      longitude: "73.09333333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Minimessa",
      atoll: "GA",
      value: "GA_Minimessa",
      alt_name: null,
      latitude: "0.541111111",
      longitude: "73.12388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Munandhuvaa",
      atoll: "GA",
      value: "GA_Munandhuvaa",
      alt_name: null,
      latitude: "0.5952777777777778",
      longitude: "73.50083333333333",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Nilandhoo",
      atoll: "GA",
      value: "GA_Nilandhoo",
      alt_name: null,
      latitude: "0.636111111",
      longitude: "73.44638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Odagallaa",
      atoll: "GA",
      value: "GA_Odagallaa",
      alt_name: null,
      latitude: "0.6625",
      longitude: "73.41833333333334",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Raaverrehaa",
      atoll: "GA",
      value: "GA_Raaverrehaa",
      alt_name: null,
      latitude: "0.7675",
      longitude: "73.42888889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Vilin'gili",
      atoll: "GA",
      value: "GA_Vilin'gili",
      alt_name: null,
      latitude: "0.754166667",
      longitude: "73.43472222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vodamulaa",
      atoll: "GA",
      value: "GA_Vodamulaa",
      alt_name: null,
      latitude: "0.603611111",
      longitude: "73.48694444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Ribidhoo",
      atoll: "GA",
      value: "GA_Ribidhoo",
      alt_name: "Ribidhuvaa",
      latitude: "0.8725",
      longitude: "73.24472222222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Baberahutta",
      atoll: "GA",
      value: "GA_Baberahutta",
      alt_name: null,
      latitude: "0.8427777777777778",
      longitude: "73.17972222222222",
      flags: [],
    },
    {
      type: "Islands",
      name: "Villigalaa",
      atoll: "GA",
      value: "GA_Villigalaa",
      alt_name: null,
      latitude: "0.5187027777777778",
      longitude: "73.21642777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kun'bumaafushi",
      atoll: "GA",
      value: "GA_Kun'bumaafushi",
      alt_name: null,
      latitude: "0.37456666666666666",
      longitude: "73.55125555555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudhebondeyyaa",
      atoll: "GA",
      value: "GA_Kudhebondeyyaa",
      alt_name: null,
      latitude: "0.4158916666666667",
      longitude: "73.57239444444444",
      flags: ["U"],
    },
    {
      type: "Knoll (Thila)",
      name: "Hagedhoo",
      atoll: "GA",
      value: "GA_Hagedhoo",
      alt_name: null,
      latitude: "0.5327777777777778",
      longitude: "73.31076388888889",
      flags: ["U"],
    },
    {
      type: "Sand Bank",
      name: "Maadhigavara",
      atoll: "GA",
      value: "GA_Maadhigavara",
      alt_name: "Maadhiguvaru",
      latitude: "0.6717666666666666",
      longitude: "73.28335",
      flags: ["U"],
    },
  ],
  GDH: [
    {
      type: "Islands",
      name: "Baulhagallaa",
      atoll: "GDH",
      value: "GDH_Baulhagallaa",
      alt_name: null,
      latitude: "0.494722222",
      longitude: "73.17222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodehutta nadella)",
      atoll: "GDH",
      value: "GDH_Bodehutta nadella)",
      alt_name: "near",
      latitude: "0.299166667",
      longitude: "73.04027778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boduhuttaa",
      atoll: "GDH",
      value: "GDH_Boduhuttaa",
      alt_name: null,
      latitude: "0.194444444",
      longitude: "73.21861111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Bodurehaa",
      atoll: "GDH",
      value: "GDH_Bodurehaa",
      alt_name: null,
      latitude: "0.383611111",
      longitude: "73.01555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dekaanbaa",
      atoll: "GDH",
      value: "GDH_Dekaanbaa",
      alt_name: null,
      latitude: "0.373611111",
      longitude: "73.0225",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dherukurehaa",
      atoll: "GDH",
      value: "GDH_Dherukurehaa",
      alt_name: null,
      latitude: "0.245833333",
      longitude: "73.11194444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigelaabadhuvaa",
      atoll: "GDH",
      value: "GDH_Dhigelaabadhuvaa",
      alt_name: "Dhigulaabaidhoo",
      latitude: "0.22",
      longitude: "73.15444444444445",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigurehaa",
      atoll: "GDH",
      value: "GDH_Dhigurehaa",
      alt_name: null,
      latitude: "0.421388889",
      longitude: "73.00472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhoonirehaa falhuthere)",
      atoll: "GDH",
      value: "GDH_Dhoonirehaa falhuthere)",
      alt_name: "Farehu",
      latitude: "0.1947222222222222",
      longitude: "73.19444444444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhoonirehaa Maavarulu)",
      atoll: "GDH",
      value: "GDH_Dhoonirehaa Maavarulu)",
      alt_name: "near",
      latitude: "0.3244444444444444",
      longitude: "73.49388888888889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Ehivakaa",
      atoll: "GDH",
      value: "GDH_Ehivakaa",
      alt_name: null,
      latitude: "0.286944444",
      longitude: "73.05444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ekelondaa",
      atoll: "GDH",
      value: "GDH_Ekelondaa",
      alt_name: null,
      latitude: "0.207777778",
      longitude: "73.17527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Farehulhedhoo",
      atoll: "GDH",
      value: "GDH_Farehulhedhoo",
      alt_name: "Farehulhudhoo",
      latitude: "0.328333333",
      longitude: "73.4975",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Faresmaathodaa",
      atoll: "GDH",
      value: "GDH_Faresmaathodaa",
      alt_name: null,
      latitude: "0.199444444",
      longitude: "73.18694444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Farukolhuhuttaa",
      atoll: "GDH",
      value: "GDH_Farukolhuhuttaa",
      alt_name: null,
      latitude: "0.195833333",
      longitude: "73.22666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Femunaidhoo",
      atoll: "GDH",
      value: "GDH_Femunaidhoo",
      alt_name: null,
      latitude: "0.237222222",
      longitude: "73.12222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fenevenehuttaa",
      atoll: "GDH",
      value: "GDH_Fenevenehuttaa",
      alt_name: null,
      latitude: "0.262222222",
      longitude: "73.09444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fiyoari",
      atoll: "GDH",
      value: "GDH_Fiyoari",
      alt_name: null,
      latitude: "0.221388889",
      longitude: "73.13638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gahdhoo",
      atoll: "GDH",
      value: "GDH_Gahdhoo",
      alt_name: null,
      latitude: "0.288888889",
      longitude: "73.45583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Velagalaa",
      atoll: "GDH",
      value: "GDH_Velagalaa",
      alt_name: "Gahevelagalaa",
      latitude: "0.3575",
      longitude: "73.32",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gan",
      atoll: "GDH",
      value: "GDH_Gan",
      alt_name: null,
      latitude: "0.277222222",
      longitude: "73.4325",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gazeeraa",
      atoll: "GDH",
      value: "GDH_Gazeeraa",
      alt_name: null,
      latitude: "0.266666667",
      longitude: "73.37666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Golhaallaa",
      atoll: "GDH",
      value: "GDH_Golhaallaa",
      alt_name: null,
      latitude: "0.320555556",
      longitude: "73.48638889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Gosi",
      atoll: "GDH",
      value: "GDH_Gosi",
      alt_name: null,
      latitude: "0.510277778",
      longitude: "73.1475",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Havoddaa",
      atoll: "GDH",
      value: "GDH_Havoddaa",
      alt_name: null,
      latitude: "0.54",
      longitude: "73.095",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Havodigalaa",
      atoll: "GDH",
      value: "GDH_Havodigalaa",
      alt_name: null,
      latitude: "0.522777778",
      longitude: "73.07416667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hevaahulhadhoo",
      atoll: "GDH",
      value: "GDH_Hevaahulhadhoo",
      alt_name: null,
      latitude: "0.300833333",
      longitude: "73.03083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hoan'dehdoo",
      atoll: "GDH",
      value: "GDH_Hoan'dehdoo",
      alt_name: null,
      latitude: "0.444166667",
      longitude: "73.00305556",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hoothodeyaa",
      atoll: "GDH",
      value: "GDH_Hoothodeyaa",
      alt_name: "IRD",
      latitude: "0.202777778",
      longitude: "73.18166667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hulhuvaarulaa",
      atoll: "GDH",
      value: "GDH_Hulhuvaarulaa",
      alt_name: "Hulhuvaarulu",
      latitude: "0.327222222",
      longitude: "73.48666667",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Hunigon'direhaa",
      atoll: "GDH",
      value: "GDH_Hunigon'direhaa",
      alt_name: null,
      latitude: "0.435",
      longitude: "73.00222222222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaadehdhoo H)",
      atoll: "GDH",
      value: "GDH_Kaadehdhoo H)",
      alt_name: "ADH,",
      latitude: "0.487222222",
      longitude: "72.99361111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaalhehuttaa - fiyoari falhuthere",
      atoll: "GDH",
      value: "GDH_Kaalhehuttaa - fiyoari falhuthere",
      alt_name: null,
      latitude: "0.226944444",
      longitude: "73.13111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaalhehuttaa - Farehu falhuthere",
      atoll: "GDH",
      value: "GDH_Kaalhehuttaa - Farehu falhuthere",
      alt_name: null,
      latitude: "0.19333333333333333",
      longitude: "73.21373611111112",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kaashidhoo",
      atoll: "GDH",
      value: "GDH_Kaashidhoo",
      alt_name: null,
      latitude: "0.334722222",
      longitude: "73.43638889",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Kaashihulhudhoo",
      atoll: "GDH",
      value: "GDH_Kaashihulhudhoo",
      alt_name: null,
      latitude: "0.395277778",
      longitude: "73.00777778",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Kadevaareha",
      atoll: "GDH",
      value: "GDH_Kadevaareha",
      alt_name: null,
      latitude: "0.4280555555555556",
      longitude: "73.00361111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudhefalaa",
      atoll: "GDH",
      value: "GDH_Kudhefalaa",
      alt_name: null,
      latitude: "0.342777778",
      longitude: "73.02611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kafena",
      atoll: "GDH",
      value: "GDH_Kafena",
      alt_name: null,
      latitude: "0.516944444",
      longitude: "72.99305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalhahigillaa",
      atoll: "GDH",
      value: "GDH_Kalhahigillaa",
      alt_name: null,
      latitude: "0.296666667",
      longitude: "73.03388889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalhahuttaa",
      atoll: "GDH",
      value: "GDH_Kalhahuttaa",
      alt_name: null,
      latitude: "0.325",
      longitude: "73.02583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kalhehamalaa",
      atoll: "GDH",
      value: "GDH_Kalhehamalaa",
      alt_name: null,
      latitude: "0.3175",
      longitude: "73.48222222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kanandhuvaa",
      atoll: "GDH",
      value: "GDH_Kanandhuvaa",
      alt_name: null,
      latitude: "0.272222222",
      longitude: "73.06861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kan'dahalagalaa",
      atoll: "GDH",
      value: "GDH_Kan'dahalagalaa",
      alt_name: null,
      latitude: "0.225",
      longitude: "73.21666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kannigillaa",
      atoll: "GDH",
      value: "GDH_Kannigillaa",
      alt_name: null,
      latitude: "0.448888889",
      longitude: "72.99833333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Keleihuttaa",
      atoll: "GDH",
      value: "GDH_Keleihuttaa",
      alt_name: null,
      latitude: "0.204166667",
      longitude: "73.17944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Keramihthaa",
      atoll: "GDH",
      value: "GDH_Keramihthaa",
      alt_name: null,
      latitude: "0.390555556",
      longitude: "73.01277778",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Keyhuvadhoo",
      atoll: "GDH",
      value: "GDH_Keyhuvadhoo",
      alt_name: null,
      latitude: "0.328888889",
      longitude: "73.02555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodaanahutta",
      atoll: "GDH",
      value: "GDH_Kodaanahutta",
      alt_name: null,
      latitude: "0.3325",
      longitude: "73.49777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodahutigalaa, Maahutigalaa, Maaodagalaa",
      atoll: "GDH",
      value: "GDH_Kodahutigalaa, Maahutigalaa, Maaodagalaa",
      alt_name: "IRD",
      latitude: "0.288611111",
      longitude: "73.20083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodedhoo",
      atoll: "GDH",
      value: "GDH_Kodedhoo",
      alt_name: null,
      latitude: "0.413055556",
      longitude: "73.00527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kodegalaa",
      atoll: "GDH",
      value: "GDH_Kodegalaa",
      alt_name: null,
      latitude: "0.367777778",
      longitude: "73.39138889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Koderataa",
      atoll: "GDH",
      value: "GDH_Koderataa",
      alt_name: null,
      latitude: "0.367777778",
      longitude: "73.02527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Konottaa",
      atoll: "GDH",
      value: "GDH_Konottaa",
      alt_name: null,
      latitude: "0.4625",
      longitude: "73.15444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kudhehulhehdhoo",
      atoll: "GDH",
      value: "GDH_Kudhehulhehdhoo",
      alt_name: null,
      latitude: "0.451944444",
      longitude: "72.99944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudhelifadhoo",
      atoll: "GDH",
      value: "GDH_Kudhelifadhoo",
      alt_name: null,
      latitude: "0.386111111",
      longitude: "73.0125",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudhemaaneidhoo",
      atoll: "GDH",
      value: "GDH_Kudhemaaneidhoo",
      alt_name: null,
      latitude: "0.258055556",
      longitude: "73.09916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudherataa",
      atoll: "GDH",
      value: "GDH_Kudherataa",
      alt_name: null,
      latitude: "0.500555556",
      longitude: "72.98944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Laihaa",
      atoll: "GDH",
      value: "GDH_Laihaa",
      alt_name: null,
      latitude: "0.251666667",
      longitude: "73.34111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lonudhoo",
      atoll: "GDH",
      value: "GDH_Lonudhoo",
      alt_name: null,
      latitude: "0.308333333",
      longitude: "73.41305556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Lonudhoohuttaa",
      atoll: "GDH",
      value: "GDH_Lonudhoohuttaa",
      alt_name: null,
      latitude: "0.301666667",
      longitude: "73.41666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Maaehivakaa",
      atoll: "GDH",
      value: "GDH_Maaehivakaa",
      alt_name: null,
      latitude: "0.2861111111111111",
      longitude: "73.05694444444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maagalaa",
      atoll: "GDH",
      value: "GDH_Maagalaa",
      alt_name: null,
      latitude: "0.369166667",
      longitude: "73.37916667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maagon'derehaa",
      atoll: "GDH",
      value: "GDH_Maagon'derehaa",
      alt_name: null,
      latitude: "0.506388889",
      longitude: "72.99055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maallaarehaa",
      atoll: "GDH",
      value: "GDH_Maallaarehaa",
      alt_name: null,
      latitude: "0.4925",
      longitude: "72.98805556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maarehaa falhuthere)",
      atoll: "GDH",
      value: "GDH_Maarehaa falhuthere)",
      alt_name: "Farehu",
      latitude: "0.19083333333333333",
      longitude: "73.20055555555555",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maavaarulu",
      atoll: "GDH",
      value: "GDH_Maavaarulu",
      alt_name: null,
      latitude: "0.336388889",
      longitude: "73.50972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maavahdhuva [ADF,H]",
      atoll: "GDH",
      value: "GDH_Maavahdhuva [ADF,H]",
      alt_name: null,
      latitude: "0.308888889",
      longitude: "73.4725",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Madaveli",
      atoll: "GDH",
      value: "GDH_Madaveli",
      alt_name: null,
      latitude: "0.458611111",
      longitude: "72.99833333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maguhdhuvaa",
      atoll: "GDH",
      value: "GDH_Maguhdhuvaa",
      alt_name: null,
      latitude: "0.277222222",
      longitude: "73.35666667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Mathaidhuvaa",
      atoll: "GDH",
      value: "GDH_Mathaidhuvaa",
      alt_name: null,
      latitude: "0.31",
      longitude: "73.02555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mathihutta",
      atoll: "GDH",
      value: "GDH_Mathihutta",
      alt_name: null,
      latitude: "0.255555556",
      longitude: "73.34055556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mathikeranahuttaa",
      atoll: "GDH",
      value: "GDH_Mathikeranahuttaa",
      alt_name: null,
      latitude: "0.400277778",
      longitude: "73.00583333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meehunthibenehuttaa",
      atoll: "GDH",
      value: "GDH_Meehunthibenehuttaa",
      alt_name: null,
      latitude: "0.260555556",
      longitude: "73.09611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Menthandhuvaa",
      atoll: "GDH",
      value: "GDH_Menthandhuvaa",
      alt_name: null,
      latitude: "0.324444444",
      longitude: "73.49138889",
      flags: ["U", "IND"],
    },
    {
      type: "Islands",
      name: "Meregihutaa",
      atoll: "GDH",
      value: "GDH_Meregihutaa",
      alt_name: null,
      latitude: "0.26916666666666667",
      longitude: "73.08111111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Meyragillaa",
      atoll: "GDH",
      value: "GDH_Meyragillaa",
      alt_name: null,
      latitude: "0.24166666666666667",
      longitude: "73.11749999999999",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bodehutta falhu theere)",
      atoll: "GDH",
      value: "GDH_Bodehutta falhu theere)",
      alt_name: "Maguhdhoo",
      latitude: "0.261111111",
      longitude: "73.34444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Mudhimaahutta",
      atoll: "GDH",
      value: "GDH_Mudhimaahutta",
      alt_name: null,
      latitude: "0.25333333333333335",
      longitude: "73.34722222222221",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Nadellaa",
      atoll: "GDH",
      value: "GDH_Nadellaa",
      alt_name: null,
      latitude: "0.293333333",
      longitude: "73.04027778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Odagallaa",
      atoll: "GDH",
      value: "GDH_Odagallaa",
      alt_name: null,
      latitude: "0.3194444444444444",
      longitude: "73.38055555555555",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Olhimuttaa",
      atoll: "GDH",
      value: "GDH_Olhimuttaa",
      alt_name: null,
      latitude: "0.34055555555555556",
      longitude: "73.02666666666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Olhurataa",
      atoll: "GDH",
      value: "GDH_Olhurataa",
      alt_name: null,
      latitude: "0.313055556",
      longitude: "73.02472222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Rahadhuvaa",
      atoll: "GDH",
      value: "GDH_Rahadhuvaa",
      alt_name: null,
      latitude: "0.496666667",
      longitude: "72.98972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Rathafandhoo",
      atoll: "GDH",
      value: "GDH_Rathafandhoo",
      alt_name: null,
      latitude: "0.2525",
      longitude: "73.10444444",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thelehuttaa",
      atoll: "GDH",
      value: "GDH_Thelehuttaa",
      alt_name: null,
      latitude: "0.28805555555555556",
      longitude: "73.05277777777778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Thinadhoo",
      atoll: "GDH",
      value: "GDH_Thinadhoo",
      alt_name: null,
      latitude: "0.530555556",
      longitude: "72.99638889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Thinahuttaa",
      atoll: "GDH",
      value: "GDH_Thinahuttaa",
      alt_name: null,
      latitude: "0.359722222",
      longitude: "73.02583333",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Uhehuttaa",
      atoll: "GDH",
      value: "GDH_Uhehuttaa",
      alt_name: null,
      latitude: "0.209166667",
      longitude: "73.17083333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ukurihuttaa",
      atoll: "GDH",
      value: "GDH_Ukurihuttaa",
      alt_name: null,
      latitude: "0.2325",
      longitude: "73.12611111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ulegalaa",
      atoll: "GDH",
      value: "GDH_Ulegalaa",
      alt_name: null,
      latitude: "0.398055556",
      longitude: "73.36972222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vaadhoo",
      atoll: "GDH",
      value: "GDH_Vaadhoo",
      alt_name: null,
      latitude: "0.227222222",
      longitude: "73.27361111",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Vaireyaadhuvaa",
      atoll: "GDH",
      value: "GDH_Vaireyaadhuvaa",
      alt_name: null,
      latitude: "0.288333333",
      longitude: "73.33722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vatavarrehaa",
      atoll: "GDH",
      value: "GDH_Vatavarrehaa",
      alt_name: null,
      latitude: "0.256111111",
      longitude: "73.29638889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Veraaviligillaa",
      atoll: "GDH",
      value: "GDH_Veraaviligillaa",
      alt_name: null,
      latitude: "0.3125",
      longitude: "73.44861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Vilin'gillaa",
      atoll: "GDH",
      value: "GDH_Vilin'gillaa",
      alt_name: null,
      latitude: "0.22944444444444445",
      longitude: "73.12944444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Rondaadhuvaa",
      atoll: "GDH",
      value: "GDH_Rondaadhuvaa",
      alt_name: null,
      latitude: "0.34694444444444444",
      longitude: "73.46388888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hakandhoo",
      atoll: "GDH",
      value: "GDH_Hakandhoo",
      alt_name: null,
      latitude: "0.29916666666666664",
      longitude: "73.03222222222222",
      flags: [],
    },
    {
      type: "Islands",
      name: "Hadaadhoo",
      atoll: "GDH",
      value: "GDH_Hadaadhoo",
      alt_name: null,
      latitude: "0.1936111111111111",
      longitude: "73.19194444444445",
      flags: [],
    },
    {
      type: "Islands",
      name: "Haveyyarataa",
      atoll: "GDH",
      value: "GDH_Haveyyarataa",
      alt_name: null,
      latitude: "0.2975",
      longitude: "73.0363888888889",
      flags: [],
    },
    {
      type: "Islands",
      name: "Haadhuvaa",
      atoll: "GDH",
      value: "GDH_Haadhuvaa",
      alt_name: null,
      latitude: "0.2388888888888889",
      longitude: "73.12194444444444",
      flags: [],
    },
    {
      type: "Islands",
      name: "Raabadaafehiratta",
      atoll: "GDH",
      value: "GDH_Raabadaafehiratta",
      alt_name: null,
      latitude: "0.23555555555555555",
      longitude: "73.12333333333332",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kaafarataa",
      atoll: "GDH",
      value: "GDH_Kaafarataa",
      alt_name: null,
      latitude: "0.30833333333333335",
      longitude: "73.02583333333334",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kandahdhoo",
      atoll: "GDH",
      value: "GDH_Kandahdhoo",
      alt_name: null,
      latitude: "0.19444444444444442",
      longitude: "73.19083333333333",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kalherehaa",
      atoll: "GDH",
      value: "GDH_Kalherehaa",
      alt_name: null,
      latitude: "0.2536111111111111",
      longitude: "73.33",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kudhehaadhuvaa",
      atoll: "GDH",
      value: "GDH_Kudhehaadhuvaa",
      alt_name: null,
      latitude: "0.24",
      longitude: "73.1211111111111",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kudhebeerahutta",
      atoll: "GDH",
      value: "GDH_Kudhebeerahutta",
      alt_name: null,
      latitude: "0.2822222222222222",
      longitude: "73.06166666666667",
      flags: [],
    },
    {
      type: "Islands",
      name: "Kudhemathaidhuvaa",
      atoll: "GDH",
      value: "GDH_Kudhemathaidhuvaa",
      alt_name: null,
      latitude: "0.30583333333333335",
      longitude: "73.02944444444444",
      flags: [],
    },
    {
      type: "Islands",
      name: "Athihuttaa",
      atoll: "GDH",
      value: "GDH_Athihuttaa",
      alt_name: null,
      latitude: "0.2797222222222222",
      longitude: "73.0625",
      flags: [],
    },
    {
      type: "Islands",
      name: "Aakiraahuttaa",
      atoll: "GDH",
      value: "GDH_Aakiraahuttaa",
      alt_name: null,
      latitude: "0.2638888888888889",
      longitude: "73.09222222222222",
      flags: [],
    },
    {
      type: "Islands",
      name: "Ekurukaarataa",
      atoll: "GDH",
      value: "GDH_Ekurukaarataa",
      alt_name: null,
      latitude: "0.2388888888888889",
      longitude: "73.11972222222222",
      flags: [],
    },
    {
      type: "Islands",
      name: "Maarehaa kairi)",
      atoll: "GDH",
      value: "GDH_Maarehaa kairi)",
      alt_name: "Nadalla",
      latitude: "0.29055555555555557",
      longitude: "73.0461111111111",
      flags: [],
    },
    {
      type: "Islands",
      name: "Fare'dhoo",
      atoll: "GDH",
      value: "GDH_Fare'dhoo",
      alt_name: null,
      latitude: "0.4013888888888889",
      longitude: "73.00472222222223",
      flags: [],
    },
    {
      type: "Islands",
      name: "Faahuttaa",
      atoll: "GDH",
      value: "GDH_Faahuttaa",
      alt_name: null,
      latitude: "0.24694444444444444",
      longitude: "73.10972222222222",
      flags: [],
    },
    {
      type: "Islands",
      name: "Faanahuttaa",
      atoll: "GDH",
      value: "GDH_Faanahuttaa",
      alt_name: null,
      latitude: "0.2997222222222222",
      longitude: "73.4038888888889",
      flags: [],
    },
    {
      type: "Islands",
      name: "Fereythavilligilla",
      atoll: "GDH",
      value: "GDH_Fereythavilligilla",
      alt_name: null,
      latitude: "0.3719444444444444",
      longitude: "73.02388888888889",
      flags: [],
    },
    {
      type: "Islands",
      name: "Dhate'keraanahutta",
      atoll: "GDH",
      value: "GDH_Dhate'keraanahutta",
      alt_name: null,
      latitude: "0.3963888888888889",
      longitude: "73.00777777777778",
      flags: [],
    },
    {
      type: "Islands",
      name: "Dhate'mulaidhoo",
      atoll: "GDH",
      value: "GDH_Dhate'mulaidhoo",
      alt_name: null,
      latitude: "0.30972222222222223",
      longitude: "73.02666666666667",
      flags: [],
    },
    {
      type: "Islands",
      name: "Dhinmanaa",
      atoll: "GDH",
      value: "GDH_Dhinmanaa",
      alt_name: null,
      latitude: "0.45",
      longitude: "72.99777777777778",
      flags: [],
    },
    {
      type: "Islands",
      name: "Lifadhoo",
      atoll: "GDH",
      value: "GDH_Lifadhoo",
      alt_name: null,
      latitude: "0.3930555555555556",
      longitude: "73.00888888888889",
      flags: [],
    },
    {
      type: "Islands",
      name: "Dhiyanigilla",
      atoll: "GDH",
      value: "GDH_Dhiyanigilla",
      alt_name: null,
      latitude: "0.3015277777777778",
      longitude: "73.0286111111111",
      flags: [],
    },
    {
      type: "Islands",
      name: "Oinigilla",
      atoll: "GDH",
      value: "GDH_Oinigilla",
      alt_name: null,
      latitude: "0.27576944444444446",
      longitude: "73.06476666666667",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhoonirehaa Nadella)",
      atoll: "GDH",
      value: "GDH_Dhoonirehaa Nadella)",
      alt_name: "near",
      latitude: "0.2683333333333333",
      longitude: "73.08388888888888",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kurikeymaahutta",
      atoll: "GDH",
      value: "GDH_Kurikeymaahutta",
      alt_name: null,
      latitude: "0.2891666666666667",
      longitude: "73.05",
      flags: [],
    },
    {
      type: "Knoll (Thila)",
      name: "Faathiyehutta",
      atoll: "GDH",
      value: "GDH_Faathiyehutta",
      alt_name: "IRD",
      latitude: "0.26916666666666667",
      longitude: "73.19416666666667",
      flags: ["U"],
    },
  ],
  GN: [
    {
      type: "Islands",
      name: "Fuvahmulah",
      atoll: "GN",
      value: "GN_Fuvahmulah",
      alt_name: null,
      latitude: "-0.295555556",
      longitude: "73.42472222",
      flags: ["I", "ADF,H"],
    },
  ],
  S: [
    {
      type: "Islands",
      name: "Aboohuraa",
      atoll: "S",
      value: "S_Aboohuraa",
      alt_name: null,
      latitude: "-0.641944444",
      longitude: "73.10444444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Bedhey aurah",
      atoll: "S",
      value: "S_Bedhey aurah",
      alt_name: null,
      latitude: "-0.589166667",
      longitude: "73.08722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Boduhajara",
      atoll: "S",
      value: "S_Boduhajara",
      alt_name: null,
      latitude: "-0.6775",
      longitude: "73.12333333",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dheeron'di",
      atoll: "S",
      value: "S_Dheeron'di",
      alt_name: null,
      latitude: "-0.594722222",
      longitude: "73.08722222",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Dhigiheraa",
      atoll: "S",
      value: "S_Dhigiheraa",
      alt_name: null,
      latitude: "-0.686388889",
      longitude: "73.13111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Fathikedeheragadu",
      atoll: "S",
      value: "S_Fathikedeheragadu",
      alt_name: null,
      latitude: "-0.6119444444444444",
      longitude: "73.14861111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Feydhoo",
      atoll: "S",
      value: "S_Feydhoo",
      alt_name: null,
      latitude: "-0.681944444",
      longitude: "73.13527778",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Gan",
      atoll: "S",
      value: "S_Gan",
      alt_name: "AIE,H",
      latitude: "-0.694444444",
      longitude: "73.15527778",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Gauken'di",
      atoll: "S",
      value: "S_Gauken'di",
      alt_name: null,
      latitude: "-0.649166667",
      longitude: "73.10694444",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Geskalhaheraa",
      atoll: "S",
      value: "S_Geskalhaheraa",
      alt_name: null,
      latitude: "-0.645833333",
      longitude: "73.2213888888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Gomahera",
      atoll: "S",
      value: "S_Gomahera",
      alt_name: null,
      latitude: "-0.6905555555555556",
      longitude: "73.18333333333334",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hankede",
      atoll: "S",
      value: "S_Hankede",
      alt_name: null,
      latitude: "-0.655833333",
      longitude: "73.11111111",
      flags: ["PR"],
    },
    {
      type: "Islands",
      name: "Herethere",
      atoll: "S",
      value: "S_Herethere",
      alt_name: null,
      latitude: "-0.635",
      longitude: "73.22416667",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hikahera",
      atoll: "S",
      value: "S_Hikahera",
      alt_name: null,
      latitude: "-0.5797222222222222",
      longitude: "73.2213888888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Hithadhoo",
      atoll: "S",
      value: "S_Hithadhoo",
      alt_name: null,
      latitude: "-0.606666667",
      longitude: "73.08916667",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Hulhudhoo",
      atoll: "S",
      value: "S_Hulhudhoo",
      alt_name: null,
      latitude: "-0.593055556",
      longitude: "73.22833333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Kan'dihera gan'du",
      atoll: "S",
      value: "S_Kan'dihera gan'du",
      alt_name: null,
      latitude: "-0.6152777777777777",
      longitude: "73.14166666666668",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Koahera",
      atoll: "S",
      value: "S_Koahera",
      alt_name: null,
      latitude: "-0.5869444444444445",
      longitude: "73.08833333333332",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Ismehelahera",
      atoll: "S",
      value: "S_Ismehelahera",
      alt_name: null,
      latitude: "-0.5772222222222222",
      longitude: "73.2125",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Kodadhihera gan'du",
      atoll: "S",
      value: "S_Kodadhihera gan'du",
      alt_name: null,
      latitude: "-0.6136111111111111",
      longitude: "73.14750000000001",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudamaahera",
      atoll: "S",
      value: "S_Kudamaahera",
      alt_name: null,
      latitude: "-0.597777778",
      longitude: "73.08888889",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maahera",
      atoll: "S",
      value: "S_Maahera",
      alt_name: null,
      latitude: "-0.5950000000000001",
      longitude: "73.09027777777777",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Maradhoo",
      atoll: "S",
      value: "S_Maradhoo",
      alt_name: null,
      latitude: "-0.665555556",
      longitude: "73.11888889",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Maradhoofeydhoo",
      atoll: "S",
      value: "S_Maradhoofeydhoo",
      alt_name: null,
      latitude: "-0.673611111",
      longitude: "73.12583333",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Meedhoo",
      atoll: "S",
      value: "S_Meedhoo",
      alt_name: null,
      latitude: "-0.583333333",
      longitude: "73.22972222",
      flags: ["I"],
    },
    {
      type: "Islands",
      name: "Mulikede",
      atoll: "S",
      value: "S_Mulikede",
      alt_name: null,
      latitude: "-0.6594444444444445",
      longitude: "73.21638888888889",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Savaaheli",
      atoll: "S",
      value: "S_Savaaheli",
      alt_name: null,
      latitude: "-0.680833333",
      longitude: "73.12611111",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Vilin'gili",
      atoll: "S",
      value: "S_Vilin'gili",
      alt_name: null,
      latitude: "-0.6744444444444444",
      longitude: "73.19444444444444",
      flags: ["R"],
    },
    {
      type: "Islands",
      name: "Hasanbeaarah",
      atoll: "S",
      value: "S_Hasanbeaarah",
      alt_name: null,
      latitude: "-0.5983333333333334",
      longitude: "73.22194444444445",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudhehera",
      atoll: "S",
      value: "S_Kudhehera",
      alt_name: null,
      latitude: "-0.5802777777777778",
      longitude: "73.22305555555556",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kudahajara",
      atoll: "S",
      value: "S_Kudahajara",
      alt_name: null,
      latitude: "-0.6794444444444444",
      longitude: "73.1236111111111",
      flags: ["U"],
    },
    {
      type: "Islands",
      name: "Kedevaahera",
      atoll: "S",
      value: "S_Kedevaahera",
      alt_name: null,
      latitude: "-0.5772222222222222",
      longitude: "73.2075",
      flags: ["U"],
    },
  ],
};


export function getAllAtollKeys(): string[] {
  return Object.keys(atollIslands);
}

